import {
  Grid,
  TextField,
  InputLabel,
  MenuItem,
  Switch,
  Button,
  FormControl,
  Select,
  Slider,
  Typography,
  Snackbar,
  Alert,
  Modal,
  Box,
  Checkbox,
  FormControlLabel,
  TextareaAutosize,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { v4 as uuidv4 } from "uuid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { LocalizationProvider, DatePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { useDispatch, useSelector } from "react-redux";
import { loadServices } from "../../../../../../Redux/Actions/CountriesActions";
import {
  loadSubServices,
  loadAddsOn,
  loadUtility,
  getPanleModels,
  getRoofTypsAction,
  getColorRoofing,
} from "../../../../../../Redux/Actions/servicesAction";
import { TotalArea } from "../../../../../../Redux/Actions/solutionsActions";
import { useLocation, useNavigate } from "react-router-dom";
import { singleLeadAction } from "../../../../../../Redux/Actions/singleLeadAction";
import { addSolarAction } from "../../../../../../Redux/Actions/addSolarAction";
import Calc from "../../../../../../components/Calc/Calc";
import { loadSunLightCalc } from "../../../../../../Redux/Actions/CalculatorActions";
import {
  AccountCircle,
  AttachMoney,
  CalculateSharp,
  CheckCircle,
  Email,
  Language,
  LocalPhone,
  LocationOn,
  Map,
  MyLocation,
} from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import Loading from "../../../../../../components/loading/Loading";
import LoadingSoultion from "../../../../../../components/loading/loadingSolution";
import CostEstemation from "./CostEstemation";
import Pusher from "pusher-js";
import pusherJs from "pusher-js";
import SystemDesign from "../../../../../../components/SystemDesign/SystemDesign";
import CalcGoodLeadp from "../../../../../../components/Calc/CalcGoodLeap";
import { goodLeapCalc } from "../../../../../../Redux/Actions/goodLeapAction";
/*----------------google-Geocoding---------------*/
import Geocode from "react-geocode";
import swal from "sweetalert";
import {
  DivFrame,
  ShowFrameBtn,
  Table,
  TableContainer,
} from "./SolarFormStyle";
import { getInstallerAdderById } from "../../../../../../Redux/Actions/AddersAction";
import FakeSunlight from "../../../../../../components/Calc/FakeSunlight";
import Mosiac from "../../../../../../components/Calc/Mosiac";
import Concert from "../../../../../../components/Calc/Concert";
import { createConcertApplication } from "../../../../../../Redux/Actions/ConcertAction";
import {
  GetAllInstallers,
  GetSingleInstallerData,
} from "../../../../../../Redux/Actions/addInstallerAction";
import InstallerMaps from "./InstallerMaps";
import FakeCalc from "../../../../../../components/Calc/fakeCalc";
import { formatPhoneNumber } from "../../../../../newProposal/components/userData/func";
/* --------- start outside drop list ----------- */

// const leadTyps = [
//   { name: "lead guaranteed", value: "lead_guaranteed" },
//   { name: "self generated", value: "self_generated" },
// ];
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "1rem",
  boxShadow: 24,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  p: 4,
};
const styleHvac = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  overflow: "scroll",
  // height: "90%",
  display: "block",
};

const installationTypes = [
  { name: "New System", value: "new_system" },
  { name: "Upgrade Existing System", value: "upgrade_existing_system" },
];

const roofMaterials = [
  { name: "Choose Roof Materials", value: "none" },
  { name: "Shingle", value: "shingle" },
  { name: "Spanish Tile", value: "spanish_tile" },
  { name: "Concrete Flat", value: "concrete_flat" },
  { name: "Flat Torch Down", value: "flat_torch_down" },
  { name: "Standing Seam Metal", value: "standing_seam_metal" },
  { name: "Presidential", value: "presidential" },
  { name: "Flat Tile", value: "flat_tile" },
  { name: "Foam", value: "foam" },
];

const shadings = [
  { name: "No Shade", value: "no_shades" },
  { name: "Partial Shade", value: "partial_shade" },
  { name: "Lots of Shade", value: "lots_of_shade" },
];
const jobTypes = [
  { name: "Roof Mount", value: "roof_mount" },
  { name: "Ground Mount", value: "ground_mount" },
  { name: "Car Port", value: "car_port" },
  { name: "Detached Garage", value: "detached_garage" },
];
const inverterTypes = [
  { name: "Solaredge", value: "solar_edge" },
  { name: "Enphase iq7", value: "enphase_iq7" },
  { name: "Enphase iq8", value: "enphase_iq8" },
  { name: "SPS inverter", value: "sps_inverter" },
];
const panelWattages = [
  { name: "365", value: "365" },
  { name: "380", value: "380" },
  { name: "400", value: "400" },
];

const panelModals = [
  { name: "FAM_E7G-BB / 120 cells", value: "FAM_E7G-BB / 120 cells " },
  { name: "Silfab NU Series SIL-400 NU", value: "Silfab NU Series SIL-400 NU" },
  { name: "Q-peak  Duo BLKML-G10", value: "Q-peak  Duo BLKML-G10" },
];
const electricalPanels = [
  { name: "50A", value: "50" },
  { name: "75A", value: "75" },
  { name: "100A", value: "100" },
  { name: "125A", value: "125" },
  { name: "175A", value: "175" },
  { name: "200A", value: "200" },
];
const UpgradPanles = [
  { name: "No Upgrade Needed", value: "0" },
  { name: "100A", value: 100 },
  { name: "125A", value: 125 },
  { name: "175A", value: 175 },
  { name: "200A", value: 200 },
];

const AirVents = [
  { name: "Exchange", value: "exchange" },
  { name: "New", value: "new" },
];
const hvacLocations = [
  { name: "Same Location", value: "same_location" },
  { name: "New Location Electrical", value: "new_location_electrical" },
  { name: "New Location Plumbing", value: "new_location_plumbing" },
  { name: "Roof Unit", value: "roof_unit" },
];

const hvacHorsePower = [
  { name: "2 TON ", value: "2_ton" },
  { name: "3 TON", value: "3_ton" },
  { name: "4 TON", value: "4_ton" },
  { name: "4 TON Split", value: "4_ton_split" },
  { name: "5 TON", value: "5_ton" },
];
const betteryPower = [
  // { name: "3KwH", value: "3KwH" },
  { name: "10KwH", value: "10KwH" },
];
const generatorPower = [
  { name: "BLUETTI 5KwH", value: "5KwH" },
  { name: "BLUETTI 10KwH", value: "10KwH" },
];
const Warranties = [
  { name: "Standard", value: "standard" },
  { name: "Premium", value: "premium" },
];

const SolarFormProposals = ({ id }) => {
  const location = useLocation();
  const leadId = Number(location.pathname.split("/")[3]);
  const serviceID = Number(location.pathname.split("/")[4]);
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const { singlead, isSingleLeadLoading } = useSelector((state) => state.leads);
  const { productMethods, createOffer, concertPayments, concertAllData } =
    useSelector((state) => state.Concert);
  // console.log("concertPayments", concertPayments);
  const { calculator, info } = useSelector((state) => state.calc);
  // console.log("infoinfoinfoinfo", info);
  const adders = useSelector((state) => state.Adders);
  const allAdders = adders?.adders?.data?.adders;
  // console.log("allAdders Soalr Form", allAdders);
  const dataAarea = useSelector((state) => state.proposal.totalArea);
  const { isLoading, isSuccess, isError, screenShot } = useSelector(
    (state) => state.proposal
  );
  const { allOffers, payments, allMosiacData } = useSelector(
    (state) => state.Mosiac
  );

  const theOfferMosiac = allOffers?.find(
    (e) => e.id == allMosiacData?.finance_product_id
  );
  const {
    utilities,
    isUtility,
    Panels,
    isPanle,
    isRoof,
    roofTyps,
    isColor,
    colors,
  } = useSelector((state) => state.services);
  console.log("roofTyps", roofTyps);
  const { all_roofing } = useSelector((state) => state.proposal);
  const { all_Adders } = useSelector((state) => state.proposal);
  const defaultPanel = Panels.find((e) => e.is_default === 1);
  // Main State
  const [value, setValue] = useState({
    lead_id: leadId,
    service_type_id: serviceID,
    opportunity_date_time: new Date(),
    is_any_non_permitted_structures: false,
    sub_service_id: "1",
    installation_type: "new_system",
    utility_provider_id: "",
    annual_kwh_usage: "",
    avg_monthly_bill: "0",
    avg_annual_bill: "",
    monthly_cost: "",
    roof_materials: "none",
    shading: "no_shades",
    panels: "",
    panel_wattage: "",
    // panel_price: "",
    add_on_id: "0",
    is_add_on: false,
    number_of_solar_arrays: "0",
    number_of_conduit_arrays: "0",
    job_type: "roof_mount",
    is_reverse_tilt: false,
    is_north_faced: false,
    two_story_home: false,
    inverter_type: "",
    royalties: "",
    is_online_monitoring: true,
    no_of_ft_from_main_service: "0",
    how_many_ft_trench_dirt: 1,
    how_many_ft_trench_concrete: "0",
    slope_degree: "0",
    digging_slope: false,
    is_separate_electrical_meter: false,
    is_electric_work_currently_on_garage: false,
    is_sub_panel_on_detached_garage: false,
    is_finance: false,
    is_attic: false,
    is_standalone_roof_mount: false,
    existing_electrical_panel: "100",
    upgrade_electrical_panel: "0",
    is_stucco: false,
    is_de_rate: false,
    is_mpu_relocation: false,
    is_more_than_3ft: true,
    number_of_mpu_relocation_foot: "0",
    is_sub_panel: false,
    is_meter_socket: false,
    is_ev_charger: false,
    is_ev_mlo: false,
    is_roof_overlay: false,
    is_re_roofing: false,
    is_roof_relay: false,
    is_re_roof_shingle: false,
    is_re_roof_tear_off: false,
    is_re_roof_presidential: false,
    is_re_roof_spanish_tiles: false,
    is_re_roof_flat_tiles: false,
    is_re_roof_re_decking: false,
    is_re_roof_fascia_board: false,
    is_air_vent: false,
    is_rafter_exchange: false,
    air_vent: "0",
    number_of_vents: "0",
    is_steep_roof: false,
    is_double_hand: false,
    is_smoke_detectors: false,
    is_warranty_extend: false,
    is_hvac: false,
    hvac_location: "0",
    hvac_horse_power: "0",
    is_ducting: false,
    number_of_ducting_run: "0",
    number_hvac_ft: "0",
    is_led_lighting: false,
    number_of_led_lighting: "0",
    is_energy_efficient_plugs: false,
    number_of_efficient_plugs: "0",
    is_solar_lip: false,
    number_of_solar_lip: "0",
    is_bird_netting: false,
    number_of_bird_netting: "0",
    is_battery: false,
    battery_power: "0",
    how_many_digging_ft: "0",
    number_of_layers: "0",
    number_of_feet: "0",
    number_of_smoke_detectors: "0",
    number_of_re_roof_squares: "0",
    number_of_batteries: "0",
    is_warranty_package: false,
    warranty: "0",
    is_trenching_dirt: false,
    is_trenching_concrete: false,
    is_steep: false,
    rate: 0,
    is_design: false,
    number_of_designated_plugs: 1,
    showButton: true,
    //start roofing
    is_roofing: false,
    roof_job_type_id: "",
    existing_roof_material_id: "",
    roof_plan_roof_material_id: "",
    number_of_old_layers: 1,
    // number_of_old_squares: 1,
    number_of_old_squares: 1,
    number_of_steep_sq: 1,
    new_roof_material_id: "",
    number_of_new_layers: 1,
    number_of_new_squares: 1,
    color_id: "",
    new_color_cost: 0,
    is_roof_planes: false,
    number_of_planes_squares: 1,
    number_of_planes_layers: 1,
    is_redecking: false,
    number_of_redecking_squares: 0,
    is_rafter: false,
    number_of_rafter_ft: 0,
    is_fascia: false,
    number_of_fascia_ft: 0,
    is_steep_pitch: false,
    roof_pitch_degree: 0,
    is_hvac_replace: false,
    number_of_hvac_units: 0,
    is_air_vent_replacement: false,
    number_of_replaced_vents: 0,
    is_new_vent: false,
    number_of_new_vents: 0,
    is_smoke_monitors: false,
    number_of_smoke_monitors: 0,
    is_double_hands: false,
    number_of_double_hand_squares: 0,
    is_monoxide_detectors: false,
    number_of_monoxide_detectors: 0,
    added_cost: 0,
    royalties_cost: 0,
    notes: "",
    tile_relay_no_of_squares: 1,
    overlay_no_of_squares: 1,
    add_work_description: "",
    add_job_type_for_roof_tile: false,
    roof_job_type_id_roof_planes: "",
    overlay_material_id_for_add_roof_planes: "",
    overlay_no_of_squares_for_add_roof_planes: 1,
    number_of_planes_squares_for_add_planes: 1,
    tile_relay_no_of_squares_for_add_roof_planes: 1,
    number_of_steep_sq_for_roof_planes: 1,
    is_sky_light: false,
    // System Design
    roof_area: 0,
    aerial_photo: "",
    financial_institution: "",
    tile_relay_no_of_squares_for_add_roof_planes_tile_relay: 1,
    number_of_planes_squares_for_add_planes_tile_relay: 1,
    overlay_no_of_squares_for_add_roof_planes_overlay: 1,
    number_of_hvacs: 1,
    is_insurance: false,
    date: "2017-05-24",
  });
  const [open, setOpen] = useState(true);
  // Add Hvac
  const [openHvac, setOpenHvac] = React.useState(false);
  const handleOpenHvac = () => setOpenHvac(true);
  const handleCloseHvac = () => setOpenHvac(false);
  const [hvacs, setHvacs] = React.useState([]);
  const [singleHvac, setSignleHvac] = React.useState();
  // Add Battery
  const [openBattery, setOpenBattery] = React.useState(false);
  const handleOpenBattery = () => setOpenBattery(true);
  const handleCloseBattery = () => setOpenBattery(false);
  const [batteries, setBatteries] = React.useState([]);
  const [singleBattery, setSignleBattery] = React.useState();
  // Add Generator
  const [openGenerator, setOpenGenerator] = React.useState(false);
  const handleOpenGenerator = () => setOpenGenerator(true);
  const handleCloseGenerator = () => setOpenGenerator(false);
  const [generators, setGenerators] = React.useState([]);
  const [singleGenerator, setSignleGenerator] = React.useState();
  const [insurance, setInurance] = React.useState();
  // start a new toggle calculator
  const [openCalc, setOpenCalc] = useState(false);
  const [offset, setOffset] = useState("");
  const [coordinates, setCoordinates] = React.useState({
    lat: "",
    lng: "",
  });
  const [showFrame, setShowFrame] = React.useState(false);
  const [roofingPrices, setRoofingPricrs] = React.useState();

  React.useEffect(() => {
    if (hvacs.length < 1) {
      setValue({ ...value, is_hvac: false });
    }
  }, [hvacs]);
  const AddHvac = async () => {
    await setHvacs((preResult) => [
      ...preResult,
      {
        hvac_location: singleHvac?.hvac_location,
        number_hvac_ft: singleHvac?.number_hvac_ft,
        hvac_horse_power: singleHvac?.hvac_horse_power,
        id: uuidv4(),
      },
    ]);
    await setValue({
      ...value,
      is_hvac: true,
    });
    await setSignleHvac(null);
    await handleCloseHvac();
  };
  const AddBattery = async () => {
    await setBatteries((preResult) => [
      ...preResult,
      {
        battery_power: singleBattery?.battery_power,
        number_of_batteries: singleBattery?.number_of_batteries,
        id: uuidv4(),
      },
    ]);
    await setValue({
      ...value,
      is_battery: true,
    });
    await setSignleBattery(null);
    await handleCloseBattery();
  };
  React.useEffect(() => {
    if (batteries.length < 1) {
      setValue({ ...value, is_battery: false });
    }
  }, [batteries]);
  React.useEffect(() => {
    if (value.installer) dispatch(GetSingleInstallerData(value.installer));
  }, [value.installer]);
  React.useEffect(() => {
    setValue({ ...value, rate: singleUtile?.rate });
  }, [singleUtile]);
  useEffect(() => {
    dispatch(loadServices());
    // dispatch(loadSubServices(id));
    dispatch(singleLeadAction(leadId));
    dispatch(loadAddsOn(id));
    // dispatch(loadSunLightCalc());
    dispatch(getPanleModels());
    dispatch(getRoofTypsAction());
    dispatch(TotalArea());
    dispatch(goodLeapCalc());
    dispatch(getInstallerAdderById(32));
    dispatch(GetAllInstallers());
    // map();
  }, []);
  React.useEffect(() => {
    dispatch(loadSunLightCalc(singlead?.state?.name));
  }, [singlead?.state?.name]);
  React.useEffect(() => {
    if (value.overlay_layers > 2) {
      swal({
        title: "Watch Out!",
        text: "You need to do Reroofing!",
        icon: "warning",
        button: "Ok",
      });
    }
  }, [value.overlay_layers]);
  useEffect(() => {
    // const ShingleColor = value.existing_roof_material_id;
    if (value.new_roof_material_id) {
      dispatch(getColorRoofing(value.new_roof_material_id));
    }
  }, [value.new_roof_material_id]);
  React.useEffect(() => {
    setValue({
      ...value,
      number_of_old_squares: Math.ceil(dataAarea / 100 + 1),
    });
  }, [dataAarea]);
  React.useEffect(() => {
    setValue({ ...value, panels: defaultPanel?.id });
  }, [defaultPanel, Panels]);
  useEffect(() => {
    if (singlead?.state?.id === 3924) {
      setValue({ ...value, inverter_type: 4 });
    }
  }, [singlead]);
  console.log("singlead?.state?.name", singlead?.state);
  const AddGenerator = async () => {
    await setGenerators((preResult) => [
      ...preResult,
      {
        generator_power: singleGenerator?.generator_power,
        number_of_generators: singleGenerator?.number_of_generators,
        id: uuidv4(),
      },
    ]);
    await setValue({
      ...value,
      is_generator: true,
    });
    await setSignleGenerator(null);
    await handleCloseGenerator();
  };
  useEffect(() => {
    if (singlead) dispatch(loadUtility(utilityID));
  }, [singlead]);

  const RoofJobsTypes = roofTyps?.roof_job_types;
  const ExistingRoofing = roofTyps?.roof_existing_materials;
  const NewRoofJobTypes = roofTyps?.roof_new_materials;
  const TileRelayMatrial = roofTyps?.tile_relay_materials || [];
  const RoofOverlayMatrials = roofTyps?.roof_overlay_materials;
  const dynamicInverters = roofTyps?.inverters || [];
  console.log("dynamicInverters", dynamicInverters);
  const UtilityProviders = utilities.utility_providers;
  // get panel from utiltites
  const PanelModelList = utilities.panels;
  //start utility depdancy
  var UtilityID = value.utility_provider_id;
  var singleUtile = UtilityProviders?.find((item) => item.id == UtilityID);
  React.useEffect(() => {
    value.rate = singleUtile?.rate;
  }, [singleUtile]);
  // console.log("setInurancesetInurancesetInurance in Parent",insurance)
  //-------------------------------------//
  // const [myDate, setMyDate] = useState(new Date());
  //state for solar panels wattegae

  // console.log("Solaaaaaaaaaaar Form all_Adders", all_Adders);
  // console.log("screenShot other component", screenShot);

  const { sunlightCalc, isCalc, totalAmount } = useSelector(
    (state) => state.calc
  );
  /*---------------Installers------------------*/
  const { allInstallers, singleINstallerData } = useSelector(
    (state) => state.installerReducer
  );
  /*-----------------GoodLeap---------------------*/
  const allDataGoodLeap = useSelector(
    (state) => state.GoodLeapReducer.allGoodLeap
  );
  const allGoodLeapOffers =
    useSelector((state) => state.GoodLeapReducer.allOffers) || [];
  const getThePayment =
    useSelector((state) => state.GoodLeapReducer.payment) || [];
  var resultFromPayment = [];

  // Get The All Result From GoodLeap
  getThePayment.map((e) => {
    resultFromPayment = e;
  });
  // Get The Calculation Form GoodLeap
  var resultFromPaymentCalc = [];
  getThePayment.map((e) => {
    resultFromPaymentCalc = e.calculations;
  });
  // Get The Term Year
  const TheOffer = allGoodLeapOffers?.find(
    (e) => e.id == getThePayment[0]?.offerId
  );
  // console.log("allDataGoodLeap allDataGoodLeap allDataGoodLeap", allDataGoodLeap);
  const utilityID = singlead?.state_id;
  const theUserLocation = singlead?.location;
  const StatName = singlead?.state?.abbr;

  // console.log("singlead",singlead)
  // get the roofing data
  // const { subServices, add_ons } = useSelector((state) => state.services);
  // const { add_ons } = useSelector((state) => state.services);

  // -------get the calc info -----------

  const YEAR_DATA = info?.term;
  const FINAL_MONTH_PAY = calculator.finalMonthlyPayment;
  const FINAL_ESC_MONTH_PAY = calculator.finalEscalatedMonthlyPayment;
  const MONTH_PAY = calculator.monthlyPayment;
  const ESC_MONTH_PAY = calculator.escalatedMonthlyPayment;
  const PAYDOWN_PERCENTAGE = calculator.paydownPercentage;
  const ALTERNATE_MONTH_PAY = calculator.alternateMonthlyPayment;

  /*------- statr for reset calc ----------*/
  // const [monthPay, setMonthPay] = useState();

  /* --------- useEffect to get sigle Lead */

  // console.log("panel",value.panel)
  // console.log(
  //   "value financial_institution financial_institution financial_institution",
  //   value.financial_institution
  // );

  // start  old JOB Type Object  Data
  const RoofJobsTypesObject = RoofJobsTypes?.find(
    (e) => e.id === value.roof_job_type_id
  );
  console.log("RoofJobsTypesObject", RoofJobsTypesObject);
  // add planes new job type
  const RoofJobsForAddPlanes = RoofJobsTypes?.find(
    (e) => e.id === value.roof_job_type_id_roof_planes
  );
  // job type for add roof planes for tile relay
  const jobTypeForRoofTileRealy = RoofJobsTypes?.find(
    (e) => e.id === value.add_roof_planes_job_type_id_for_roof_tile
  );
  // job type for add roof planes for roof overlay
  const jobTypeForRoofRoofOverlay = RoofJobsTypes?.find(
    (e) => e.id === value.add_roof_planes_job_type_id_for_roof_overlay
  );
  // console.log("Value", value);
  // console.log(
  //   "jobTypeForRoofRoofOverlay jobTypeForRoofRoofOverlay jobTypeForRoofRoofOverlay",
  //   jobTypeForRoofRoofOverlay
  // );
  // get Tile Relay data

  const TileRelayMaterial = TileRelayMatrial.find(
    (e) => e.id === value.tile_relay_material_id
  );
  // console.log("TileRelayMatrial check for array", TileRelayMaterial);

  // Tile Relay For add Roof Planes Tile Relay
  const TileRelayForAddRoofPlanesTileRelay = TileRelayMatrial?.find(
    (e) => e.id === value.tile_relay_material_id_for_add_roof_planes_tile_relay
  );
  // Tile Relay For add Roof Planes
  const TileRelayForAddRoofPlanes = TileRelayMatrial?.find(
    (e) => e.id === value.tile_relay_material_id_for_add_roof_planes
  );
  // Overlay Roof For add Roof Planes
  const RoofOverLayForAddRoofPlanes = RoofOverlayMatrials?.find(
    (e) => e.id === value.overlay_material_id_for_add_roof_planes
  );
  // Re Roofing Material for Add Planes Tile Relay
  const ReRoofingMaterialForAddPlanesTileRelay = ExistingRoofing?.find(
    (e) => e.id === value.planes_material_id_for_add_planes_tile_relay
  );
  // Re Roofing Material for Add Planes Roof Overlay
  const ReRoofingMaterialForAddPlanesRoofOverlay = ExistingRoofing?.find(
    (e) => e.id === value.planes_material_id_for_add_planes_roof_overlay
  );
  // start  old exisiting e Object  Data
  const ExistingRoofingObject = ExistingRoofing?.find(
    (e) => e.id === value.existing_roof_material_id
  );

  // start  old JOB Type Object  Data
  const NewRoofJobTypesObject = NewRoofJobTypes?.find(
    (e) => e.id === value.new_roof_material_id
  );
  // object color in roofing
  const colorObject = colors?.find((e) => e.id === value.color_id);
  // new Roofing Overlay Material
  const newRooginOverLay = NewRoofJobTypes?.filter(
    (e) => e.id === 1 || e.id === 2 || e.id === 3
  );
  const overlayNewMaterial = NewRoofJobTypes?.find(
    (e) => e.id === value.overlay_new_roof_material_id
  );
  const overlayNewMaterialPlanes = NewRoofJobTypes?.find(
    (e) => e.id === value.overlay_planes_new_roof_material_id
  );
  const tileRelayNewMaterialPlanes = NewRoofJobTypes?.find(
    (e) => e.id === value.tileRelay_overlay_new_roof_material_id
  );
  const reroofNewMaterialPlanes = NewRoofJobTypes?.find(
    (e) => e.id === value.reroof_overlay_new_roof_material_id
  );
  // get Tile Relay data
  // const TileRelayMaterial = TileRelayMatrial.find(
  //   (e) => e.id === value.tile_relay_material_id
  // );

  const TileRelayForAddRoofPlanesOverLay = TileRelayMatrial?.find(
    (e) =>
      e.id === value.tile_relay_material_id_for_add_roof_planes_roof_overlay
  );

  // Set The initial value for value.rate

  // start math for offset
  const NumberOfPanelsNeeded = Math.ceil(
    value.annual_kwh_usage / 365 / 4.2 / (value.panel_wattage / 1000)
  );
  // new Roof plan matrial
  const NewRoofPlanMatrial = ExistingRoofing?.find(
    (e) => e.id === value.planes_material_id
  );
  // new Roof plan matrial of add planes
  const NewRoofPlanMatrialPlanes = NewRoofJobTypes?.find(
    (e) => e.id === value.new_planes_material_id
  );
  // Re Roofing Material for Add Planes
  const ReRoofingMaterialForAddPlanes = ExistingRoofing?.find(
    (e) => e.id === value.planes_material_id_for_add_planes
  );

  const TotalPanle =
    NumberOfPanelsNeeded + Number(value.number_of_solar_arrays);
  const SystemSize = TotalPanle * value.panel_wattage;
  const AnnualPrduction = (SystemSize / 1000) * 365 * 4.2;
  const OffsetPercentage = Math.ceil(
    (AnnualPrduction / value.annual_kwh_usage) * 100
  );

  // start cost math for sealer
  const AC_Ratio = AnnualPrduction * 0.14;
  const SystemOutput_AC = AnnualPrduction - AC_Ratio;

  // get the single panel
  const PanelID = value?.panels;
  const SinglePanel = Panels?.find((el) => el?.id == PanelID);
  const DataApi = {
    panel_price: SinglePanel?.price,
    apr: info.apr,
    loan_years: YEAR_DATA || 25,
    monthlyPayment: MONTH_PAY,
    finalMonthlyPayment: FINAL_MONTH_PAY,
    finalEscalatedMonthlyPayment: FINAL_ESC_MONTH_PAY,
    escalatedMonthlyPayment: ESC_MONTH_PAY,
    // apr: TheOffer?.rate,
    sl_dealer_fee: info.dealer_fee,
    sl_deposit: info?.deposit,
    loan_amount: totalAmount || 0,
    annual_increases_percentage: singleUtile?.annual_increase_percentage,
    // loan_years: TheOffer?.term || 25,
    // finalMonthlyPayment: resultFromPaymentCalc[0]?.roundedAmount?.value,
    // finalEscalatedMonthlyPayment:
    // resultFromPaymentCalc[1]?.roundedAmount?.value,
    // monthlyPayment: resultFromPaymentCalc[0]?.roundedAmount?.value,
    // escalatedMonthlyPayment: resultFromPaymentCalc[1]?.roundedAmount?.value,
    paydownPercentage: PAYDOWN_PERCENTAGE,
    alternateMonthlyPayment: ALTERNATE_MONTH_PAY,
  };
  const OfferData = allGoodLeapOffers?.find(
    (e) => e.id == allDataGoodLeap?.offers[0]
  );
  // console.log("allInstallers", allInstallers);
  const goodleapOfferId = allDataGoodLeap?.offers || [];
  var id = "";
  goodleapOfferId.map((e) => {
    id = e;
  });
  // console.log("allOffers", allOffers);
  const good_leap_promotion = allDataGoodLeap?.promotion || [];
  const goodLeapData = {
    offer_id: id,
    paydown_amount: allDataGoodLeap?.extraPaydownAmount,
    paydown_percent: allDataGoodLeap?.extraPaydownPercent / 100,
    category_id: allDataGoodLeap?.category,
    gl_dealer_fee: OfferData?.dealerFee,
    gl_rate: OfferData?.rate,
    gl_term: OfferData?.term,
    gl_promotion_id: good_leap_promotion[0],
  };
  // console.log("goodLeapData", goodLeapData);

  const mosiacData = {
    mosaic_finance_product_id: allMosiacData?.finance_product_id,
    mosaic_financing_product_type: payments?.financingProductType,
    mosaic_total_periods: payments?.totalPeriods,
    mosaic_rate: payments?.rate,
    mosaic_rate_without_ach_discount: payments?.rateWithoutAchDiscount,
    mosaic_dealer_fee: payments?.dealerFee,
    mosaic_monthly_payments: payments?.monthlyPayments,
    mosaic_is_ach: +allMosiacData?.mosaic_is_ach,
    mosaic_monthly_payments_with_prepayment:
      payments?.monthlyPaymentsWithPrePayment,
    mosaic_prepayment_amount: payments?.prePaymentAmount,
  };

  const concertData = {
    concert_apr: concertAllData?.apr,
    concert_deferral_months: concertAllData?.deferral_months,
    concert_loan_type: concertAllData?.loan_type,
    concert_term: concertAllData?.term,
    concert_pre_payment_percent: concertAllData?.pre_payment_percent,
    concert_dealer_fee: concertAllData?.concert_dealer_fee,
  };

  // console.log("concertData", concertData);
  // console.log("concertAllData", concertAllData);

  let sendHvacs = {
    hvacs: hvacs,
  };
  let sendBatteries = {
    batteries: batteries,
  };
  let sendInurance = {
    insurance: insurance,
  };
  let sendGenerators = {
    generators: generators,
  };
  // console.log("roofingPrices", roofingPrices);
  let prices = {
    redecking_cost: value?.is_redecking
      ? allAdders?.redecking?.pivot?.price * value?.number_of_redecking_squares
      : 0,
    rafter_cost: value.is_rafter
      ? allAdders?.rafter?.pivot?.price * value.number_of_rafter_ft
      : 0,
    fascia_cost: value.is_fascia
      ? allAdders?.fascia?.pivot?.price * value.number_of_fascia_ft
      : 0,
    hvac_replace_cost: value.is_hvac_replace
      ? allAdders?.hvac_replace?.pivot?.price * value.number_of_hvac_units
      : 0,
    air_vent_replacement_cost: value?.is_air_vent_replacement
      ? allAdders?.air_vent_replacement?.pivot?.price *
        value.number_of_replaced_vents
      : 0,
    new_vent_cost: value?.is_new_vent
      ? allAdders?.new_air_vent?.pivot?.price * value?.number_of_new_vents
      : 0,
    smoke_monitors_cost: value?.is_smoke_monitors
      ? allAdders?.smoke_monitors?.pivot?.price * value.number_of_smoke_monitors
      : 0,
    double_hands_cost: value?.is_double_hands
      ? allAdders?.double_hand?.pivot?.price *
        value.number_of_double_hand_squares
      : 0,
    monoxide_detectors_cost: value.is_monoxide_detectors
      ? allAdders?.monoxide_detectors?.pivot?.price
      : 0,
    job_type_cost:
      all_roofing?.TileRelayCost ||
      all_roofing?.overlayCost ||
      all_roofing?.EXISTING_ROOF_COST + all_roofing?.STEEP_ROOF_COST,
    job_planes_cost:
      all_roofing?.cost_add_roof_planes_tile_relay ||
      all_roofing?.cost_add_roof_planes_overlay ||
      all_roofing?.reRoofing_for_add_roof_planes_tile_relay +
        all_roofing?.CostOfLayers_for_add_roof_planes_tile_relay +
        all_roofing?.STEEP_ROOF_COST_for_add_roof_planes_tile_relay ||
      all_roofing?.cost_add_roof_planes_roof_overlay ||
      all_roofing?.cost_add_roof_planes_overlay_overlay ||
      all_roofing?.reRoofing_for_add_roof_planes_roof_overlay +
        all_roofing?.CostOfLayers_for_add_roof_planes_roof_overlay +
        all_roofing?.STEEP_ROOF_COST_for_add_roof_planes_roof_overlay ||
      all_roofing?.roof_tile_for_add_roof_planes ||
      all_roofing?.reRoofing_for_add_roof_planes ||
      all_roofing?.roof_overlay_for_add_roof_planes,
    new_roofing_cost: all_roofing?.NEW_ROOF_JOB_TYPE_COST,
  };
  // console.log("Prices ", prices);
  value.aerial_photo = screenShot;

  const HandelSubmit = (e) => {
    e.preventDefault();
    if (value.aerial_photo === undefined) {
      swal({
        // title: "Congratulations You finally did it and ScreenShot Taken",
        title: "Take ScreenShot Please!",
        icon: "warning",
        dangerMode: false,
      });
      window.scrollTo({
        top: 2000,
        left: 2000,
        behavior: "smooth",
      });
    } else {
      // e.preventDefault();
      dispatch(
        addSolarAction({
          ...value,
          ...DataApi,
          ...goodLeapData,
          ...sendHvacs,
          ...sendBatteries,
          ...sendInurance,
          ...sendGenerators,
          ...all_Adders,
          ...mosiacData,
          ...concertData,
          prices,
        })
      );
    }
  };
  const handleAddLead = () => {
    Navigate(`/crm/leads/${leadId}/${serviceID}`);
    window.location.reload(false);
  };
  const handleGoToLeads = () => {
    Navigate(`/profilelead/${leadId}/solutions`);
    window.location.reload(false);
  };
  /*-----------------------------LEAFLET-------------------------- */
  // value.roof_area = dataAarea * 10.764;

  // console.log("coordinatescoordinatescoordinates", singlead.lat);
  // console.log("singleadsingleadsinglead",singlead.lat)
  // console.log("singleadsingleadsinglead",singlead.lng)
  if (singlead?.lat === null || singlead?.lat === "") {
    Geocode.setLocationType("ROOFTOP");
    Geocode.setApiKey("AIzaSyCrr_bBNHxQ0lZKadmJYpqS2vOebczD1m4");
    // React.useEffect(() => {
    Geocode.fromAddress(theUserLocation).then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        // console.log(lat, lng);
        coordinates.lat = lat;
        coordinates.lng = lng;
      },
      (error) => {
        console.error(error);
      }
    );
  } else {
    coordinates.lat = singlead?.lat;
    coordinates.lng = singlead?.lng;
    // }, [coordinates]);
  }

  if (value.is_finance === false) {
    value.financial_institution = "";
  }
  if (value.is_finance === false) {
    value.financial_institution = "";
  }
  // calculate number of roofs squares
  // console.log("dataArea", dataAarea);
  let roofSquares = Number(dataAarea / 100) + 1;

  const deleteFromLicenses = (id) => {
    const newHvac = [...hvacs];
    const index = hvacs.findIndex((e) => e.id === id);
    // console.log("TheRow", index);
    newHvac.splice(index, 1);
    setHvacs(newHvac);
  };
  const deleteFromBatteries = (id) => {
    const newBattery = [...batteries];
    const index = batteries.findIndex((e) => e.id === id);
    // console.log("TheRow", index);
    newBattery.splice(index, 1);
    setBatteries(newBattery);
  };
  const deleteFromGenerators = (id) => {
    const newGenerator = [...generators];
    const index = generators.findIndex((e) => e.id === id);
    // console.log("TheRow", index);
    newGenerator.splice(index, 1);
    setGenerators(newGenerator);
  };
  // console.log("singlead", singlead?.id);
  let mosaicPaymentWithPrePayment =
    payments?.monthlyPaymentsWithPrePayment?.filter(function (
      element,
      index,
      array
    ) {
      return ++index % 2 === 0;
    });
  // let CommaFormatted = (amount) => {
  //   var delimiter = ","; // replace comma if desired
  //   var a = amount?.split(".", 2);
  //   var d = a[1];
  //   var i = parseInt(a[0]);
  //   if (isNaN(i)) {
  //     return "";
  //   }
  //   var minus = "";
  //   if (i < 0) {
  //     minus = "-";
  //   }
  //   i = Math.abs(i);
  //   var n = new String(i);
  //   var a = [];
  //   while (n.length > 3) {
  //     var nn = n.substr(n.length - 3);
  //     a.unshift(nn);
  //     n = n.substr(0, n.length - 3);
  //   }
  //   if (n.length > 0) {
  //     a.unshift(n);
  //   }
  //   n = a.join(delimiter);
  //   if (d.length < 1) {
  //     amount = n;
  //   } else {
  //     amount = n + "." + d;
  //   }
  //   amount = minus + amount;
  //   return amount;
  // };
  let CommaFormatted = (num) => {
    // return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return Intl.NumberFormat("en-US").format(num);
  };
  const handleChange = (event) => {
    setValue({ ...value, discount_type: event.target.value });
  };
  // console.log("value.installer", value.installer);
  // console.log("singleINstallerData", singleINstallerData);
  return (
    <>
      {!isSingleLeadLoading && !isCalc && !isUtility && !isPanle && !isRoof && (
        <>
          {/*  START  ICON TOGGLE CALC */}
          <CalcToggle onClick={() => setOpenCalc(!openCalc)}>
            <CalculateSharp />
          </CalcToggle>
          <CostEstemation
            panelPrice={DataApi.panel_price}
            ToggleCalc={openCalc}
            NumberOfPanls={TotalPanle}
            DC={SystemSize}
            AC={SystemOutput_AC}
            ISfinance={value.is_finance}
            AnnualPrduction={AnnualPrduction}
            InvertType={value.inverter_type}
            IsTowStory={value.two_story_home}
            IsReverseTilt={value.is_reverse_tilt}
            IsNorthFaced={value.is_north_faced}
            RoofMaterials={value.roof_materials}
            IsAttic={value.is_attic}
            NumberOfAttics={value.number_of_conduit_arrays}
            IsOnlineMonitoring={value.is_online_monitoring}
            JopType={value.job_type}
            IsTrenching={value.is_trenching_dirt}
            HowManyTrench={value.how_many_ft_trench_dirt}
            IsTrenchingConcret={value.is_trenching_concrete}
            HowManyConcret={value.how_many_ft_trench_concrete}
            IsStandAloneRoof={value.is_standalone_roof_mount}
            IsDiggingSlope={value.digging_slope}
            HowManyDigging={value.how_many_digging_ft}
            ExistingElectricalPanel={value.upgrade_electrical_panel}
            IsStucco={value.is_stucco}
            IsDeRate={value.is_de_rate}
            ISMPU={value.is_mpu_relocation}
            ISMPUMore3={value.is_more_than_3ft}
            NumberOfMPU={value.number_of_mpu_relocation_foot}
            IsSubPanel={value.is_sub_panel}
            IsMeterSocket={value.is_meter_socket}
            IsEV={value.is_ev_charger}
            IsEVMLO={value.is_ev_mlo}
            IsReRoofing={value.is_re_roofing}
            NumberOfReroofSquares={value.number_of_re_roof_squares}
            IsRoofRelay={value.is_roof_relay}
            IsReRoofShingle={value.is_re_roof_shingle}
            IsReRoofTear={value.is_re_roof_tear_off}
            NumberOfLayers={value.number_of_layers}
            IsReRoofPresidential={value.is_re_roof_presidential}
            IsReRoofSpanish={value.is_re_roof_spanish_tiles}
            IsReRoofFlat={value.is_re_roof_flat_tiles}
            IsReRoofReDecking={value.is_re_roof_re_decking}
            IsReRoofFascia={value.is_re_roof_fascia_board}
            NumberOfFeet={value.number_of_feet}
            IsRafterExchange={value.is_rafter_exchange}
            IsAirVet={value.is_air_vent}
            AirVent={value.air_vent}
            NumberOfVent={value.number_of_vents}
            IsDoubleHand={value.is_double_hand}
            IsSmoke={value.is_smoke_detectors}
            NumberOfSmoke={value.number_of_smoke_detectors}
            IsWarrantyExtend={value.is_warranty_extend}
            IsHVAC={value.is_hvac}
            HvacLocation={value.hvac_location}
            HvacHorsPower={value.hvac_horse_power}
            NumberOfHvacFt={value.number_hvac_ft}
            IsDucting={value.is_ducting}
            NumberOfDuctingRun={value.number_of_ducting_run}
            IsEnergyEfficient={value.is_energy_efficient_plugs}
            NumberOfEfficient={value.number_of_efficient_plugs}
            IsolarLip={value.is_solar_lip}
            NumberOfSolarLip={value.number_of_solar_lip}
            IsBirdNetting={value.is_bird_netting}
            NumberOfBirdNetting={value.number_of_bird_netting}
            IsBattery={value.is_battery}
            NumberOfBattery={value.number_of_batteries}
            BatteryPower={value.battery_power}
            IsWarrantyPackage={value.is_warranty_package}
            Warranty={value.warranty}
            IsSteep={value.is_steep}
            Royaltiy={value.royalties}
            value={value}
            RoofJobsTypesObject={RoofJobsTypesObject}
            ExistingRoofingObject={ExistingRoofingObject}
            NewRoofJobTypesObject={NewRoofJobTypesObject}
            colorObject={colorObject}
            NewRoofPlanMatrial={NewRoofPlanMatrial}
            is_roof_planes={value.is_roof_planes}
            Roof_plane_squares={value.number_of_planes_squares}
            Roof_plane_layers={value.number_of_planes_layers}
            Tile_Rekay_no_squares={value.tile_relay_no_of_squares}
            overlay_no_of_squares={value.overlay_no_of_squares}
            NewRoofPlanMatrialPlanes={NewRoofPlanMatrialPlanes}
            RoofJobsForAddPlanes={RoofJobsForAddPlanes}
            TileRelayForAddRoofPlanes={TileRelayForAddRoofPlanes}
            RoofOverLayForAddRoofPlanes={RoofOverLayForAddRoofPlanes}
            ReRoofingMaterialForAddPlanes={ReRoofingMaterialForAddPlanes}
            jobTypeForRoofTileRealy={jobTypeForRoofTileRealy}
            TileRelayForAddRoofPlanesTileRelay={
              TileRelayForAddRoofPlanesTileRelay
            }
            ReRoofingMaterialForAddPlanesTileRelay={
              ReRoofingMaterialForAddPlanesTileRelay
            }
            jobTypeForRoofRoofOverlay={jobTypeForRoofRoofOverlay}
            ReRoofingMaterialForAddPlanesRoofOverlay={
              ReRoofingMaterialForAddPlanesRoofOverlay
            }
            overlayNewMaterial={overlayNewMaterial}
            TileRelayMaterial={TileRelayMaterial}
            TileRelayForAddRoofPlanesOverLay={TileRelayForAddRoofPlanesOverLay}
            overlayNewMaterialPlanes={overlayNewMaterialPlanes}
            tileRelayNewMaterialPlanes={tileRelayNewMaterialPlanes}
            reroofNewMaterialPlanes={reroofNewMaterialPlanes}
            singleUtile={singleUtile}
            hvacs={hvacs}
            batteries={batteries}
            updateInsurance={setInurance}
            generators={generators}
            roofingPrices={roofingPrices}
            updateRoofingPrices={setRoofingPricrs}
          />
          <FormConatiner>
            <UserData>
              <h2 className="leadInfo">Lead Info.</h2>

              <Grid container columns={18} spacing={3}>
                <Grid item md={9} xs={18}>
                  <div className="data">
                    <h4 className="key">
                      <AccountCircle /> name
                    </h4>
                    <span className="value">
                      {singlead.first_name} {singlead.last_name}
                    </span>
                  </div>
                  <div className="data">
                    <h4 className="key">
                      <LocalPhone /> phone
                    </h4>
                    <span className="value">
                      {singlead?.phone
                        ? `${formatPhoneNumber(singlead?.phone)}`
                        : "No phone"}
                    </span>
                  </div>
                  <div className="data">
                    <h4 className="key">
                      <LocalPhone /> mobile
                    </h4>
                    <span className="value">
                      {formatPhoneNumber(singlead?.mobile)}
                    </span>
                  </div>
                  <div className="data">
                    <h4 className="key">
                      <Email /> email
                    </h4>
                    <span className="value">{singlead.email}</span>
                  </div>
                  <div className="data">
                    <h4 className="key">
                      <AttachMoney /> price
                    </h4>
                    <span className="value">${singlead.price}</span>
                  </div>
                </Grid>
                <Grid item md={9} xs={18}>
                  <div className="data">
                    <h4 className="key">
                      <Language /> country
                    </h4>
                    <span className="value">{singlead.country.name}</span>
                  </div>
                  <div className="data">
                    <h4 className="key">
                      <LocationOn /> state
                    </h4>
                    <span className="value">{singlead.state.name}</span>
                  </div>
                  <div className="data">
                    <h4 className="key">
                      <MyLocation /> street
                    </h4>
                    <span className="value">{singlead.street}</span>
                  </div>

                  <div className="data">
                    <h4 className="key">
                      <Map /> zip code
                    </h4>
                    <span className="value">{singlead.zip_code}</span>
                  </div>
                </Grid>
              </Grid>
            </UserData>
            <SolarHeading>
              <h2>Solar Solution</h2>
            </SolarHeading>

            <form onSubmit={HandelSubmit}>
              <Grid item container spacing={2} columns={18}>
                <Grid item xs={18} mb={3}>
                  <h3>Utility Info.</h3>
                  <hr />
                </Grid>

                {/*utility_provider_id  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControl fullWidth required={true}>
                    <InputLabel id="demo-simple-select-label">
                      Utility Provider
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={value.utility_provider_id}
                      label="Utility Provider"
                      required={true}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          utility_provider_id: e.target.value,
                        })
                      }
                    >
                      {UtilityProviders?.map((util) => (
                        <MenuItem key={util.id} value={util.id}>
                          {util.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {/* 
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControl fullWidth>
                    <TextField
                      select
                      label="Utility Provider "
                      required
                      value={value.utility_provider_id}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          utility_provider_id: e.target.value,
                        })
                      }
                    >
                      {UtilityProviders?.map((util) => (
                        <MenuItem key={util.id} value={util.id}>
                          {util.title}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormControl>
                </Grid> */}

                {/* Rate  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  {/* <TextField
                    fullWidth
                    required
                    id="outlined-basic"
                    variant="outlined"
                    label="Rate"
                    // type="number"
                    // step="0.01"
                    disabled={true}
                    value={(value.rate = singleUtile?.rate) || "Rate"}
                    onChange={(e) =>
                      setValue({ ...value, rate: Number(e.target.value) }) ||
                      false
                    }
                  /> */}

                  <TextField
                    fullWidth
                    required
                    id="outlined-basic"
                    variant="outlined"
                    label="Rate"
                    type="text"
                    // step="any"
                    // disabled={true}
                    value={value.rate}
                    onChange={(e) =>
                      setValue({ ...value, rate: e.target.value })
                    }
                  />
                </Grid>

                {/* Annual Kwh Usage */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  {/* <InputLabel> Annual Kwh Usage </InputLabel> */}
                  <TextField
                    fullWidth
                    required
                    label="Annual Consumption"
                    // type="number"
                    value={value.annual_kwh_usage}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        annual_kwh_usage: Number(e.target.value),
                      })
                    }
                  />
                </Grid>
                {/* Avg Monthly Bill  */}
                {/* 
          <Grid item md={6} sm={9} xs={18} mb={3}>
            <InputLabel>Avg Monthly Bill</InputLabel>
            <TextField
              fullWidth
              required
              type="number"
              value={value.avg_monthly_bill}
              onChange={(e) =>
                setValue({ ...value, avg_monthly_bill: Number(e.target.value) })
              }
            />
          </Grid> */}
                {/* Avg Annual Bill */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    required
                    fullWidth
                    disabled={true}
                    label="Annually Cost $"
                    // type="number"
                    value={
                      Math.ceil(
                        (value.avg_annual_bill =
                          value.annual_kwh_usage * value.rate)
                      ) || "Annually Cost $"
                    }
                    onChange={(e) =>
                      setValue({
                        ...value,
                        avg_annual_bill: Number(e.target.value),
                      }) || false
                    }
                  />
                </Grid>
                {/* Monthly Cost  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    required
                    fullWidth
                    disabled={true}
                    label="Monthly Cost $"
                    value={
                      Math.floor(
                        (value.monthly_cost =
                          (value.annual_kwh_usage * value.rate) / 12)
                      ) || "Monthly Cost $"
                    }
                    onChange={(e) =>
                      setValue({
                        ...value,
                        monthly_cost: Number(e.target.value),
                      }) || false
                    }
                  />
                </Grid>
                {/* Installers info */}
                {/* <Grid item xs={18} mb={3} >
                  <h3>Installer Info.</h3>
                  <hr />
                </Grid>
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControl fullWidth>
                    <TextField
                      select
                      label="Select installer "
                      required
                      value={value.installer}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          installer: e.target.value,
                        })
                      }
                    >
                      {allInstallers?.data?.map((installer) => (
                        <MenuItem key={installer.id} value={installer.id}>
                          {installer.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormControl>
                </Grid>
                <Grid item xs={18}>
                  <InstallerMaps
                    installerId={value.installer}
                    allInstallers={allInstallers}
                    singlead={singlead}
                  />
                </Grid> */}
                {/* --------- START JOB TYPE ---------- */}
                <Grid item xs={18} mb={3}>
                  <h3>Job Info.</h3>
                  <hr />
                </Grid>

                {/* Installation Type  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControl fullWidth>
                    <TextField
                      select
                      label="Installation Type "
                      required
                      value={value.installation_type}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          installation_type: e.target.value,
                        })
                      }
                    >
                      {installationTypes.map((serve) => (
                        <MenuItem key={serve.value} value={serve.value}>
                          {serve.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormControl>
                </Grid>

                {/*  JOB types  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    required
                    select
                    fullWidth
                    label="System Types"
                    value={value.job_type}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        job_type: e.target.value,
                      })
                    }
                  >
                    {jobTypes.map((job) => (
                      <MenuItem key={job.value} value={job.value}>
                        {job.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {value.job_type === "roof_mount" ? (
                  <>
                    {/* Roof Materials  D */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        select
                        label="Roof Materials"
                        fullWidth
                        value={value.roof_materials}
                        onChange={(e) =>
                          setValue({ ...value, roof_materials: e.target.value })
                        }
                      >
                        {roofMaterials.map((serve) => (
                          <MenuItem key={serve.value} value={serve.value}>
                            {serve.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    {/* slope_degree  */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Roof Pitch Degree "
                        value={value.slope_degree}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            slope_degree: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>
                    {/* two_story_home*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>2 Story Home</InputLabel>
                      <Switch
                        checked={value.two_story_home}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            two_story_home: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Grid>
                  </>
                ) : null}

                {value.job_type !== "roof_mount" ? (
                  <>
                    {/* is_trenching_dirt*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Trenching Dirt </InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_trenching_dirt}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_trenching_dirt: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid>
                    {value.is_trenching_dirt && (
                      <>
                        {/* how_many_ft_trench_dirt  */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="How Many ft Trench Dirt"
                            type="number"
                            value={value.how_many_ft_trench_dirt}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                how_many_ft_trench_dirt: e.target.valueAsNumber,
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/* is_trenching_concrete*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Trenching Concrete </InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_trenching_concrete}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_trenching_concrete: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid>
                    {value.is_trenching_concrete && (
                      <>
                        {/* how_many_ft_trench_concrete */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="How Many ft Trench Concrete"
                            value={value.how_many_ft_trench_concrete}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                how_many_ft_trench_concrete: Number(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}
                  </>
                ) : null}

                {/* Opportunity Date Time */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControl fullWidth required>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      required={true}
                    >
                      <DatePicker
                        fullWidth
                        required={true}
                        label="Opportunity Date Time"
                        value={value.opportunity_date_time}
                        onChange={(e) =>
                          setValue({ ...value, opportunity_date_time: e })
                        }
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>

                {/* ------ START SYSTEM INFORMATION ---------- */}
                <Grid item xs={18} mb={3}>
                  <h3> System Information</h3>
                  <hr />
                </Grid>

                {/* panels  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  {/* <TextField
              required
              fullWidth
              label="Panels Model"
              value={value.panels}
              onChange={(e) =>
                setValue({
                  ...value,
                  panels: e.target.value,
                })
              }
            /> */}
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Panel Models
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      required
                      value={value.panels}
                      label="Panel Modelss"
                      onChange={(e) =>
                        setValue({ ...value, panels: e.target.value })
                      }
                    >
                      {Panels?.map((panel) => (
                        <MenuItem value={panel.id} key={panel.id}>
                          {panel.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {/* <FormControl fullWidth>
                    {PanelModelList?.length !== 0 ? (
                      <>
                        <InputLabel id="demo-simple-select-label">
                          Panel Models
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          required
                          value={value.panels}
                          label="Panel Modelss"
                          onChange={(e) =>
                            setValue({ ...value, panels: e.target.value })
                          }
                        >
                          {PanelModelList?.map((panel) => (
                            <MenuItem value={panel.id} key={panel.id}>
                              {panel.title}
                            </MenuItem>
                          ))}
                        </Select>
                      </>
                    ) : (
                      <>
                        <InputLabel id="demo-simple-select-label">
                          Panel Models
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          required
                          value={value.panels}
                          label="Panel Modelss"
                          onChange={(e) =>
                            setValue({ ...value, panels: e.target.value })
                          }
                        >
                          {panelModals.map((panel) => (
                            <MenuItem value={panel.name} key={panel.name}>
                              {panel.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </>
                    )}
                  </FormControl> */}
                </Grid>
                {/* Panel Wattage  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    fullWidth
                    disabled={true}
                    label="Panel Wattage"
                    value={(value.panel_wattage = SinglePanel?.wattage || "")}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        panel_wattage: Number(e.target.value),
                      }) || false
                    }
                  />
                  {/* {panelWattages.map((panel) => (
                      <MenuItem key={panel.value} value={panel.value}>
                        {panel.name}
                      </MenuItem>
                    ))} */}
                  {/* </TextField> */}
                </Grid>

                {/* Panel Wattage  */}
                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    fullWidth
                    label="Panel Price"
                    disabled={true}
                    value={(value.panel_price = SinglePanel?.price || "")}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        panel_price: Number(e.target.value),
                      }) || false
                    }
                  />
                </Grid> */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <Typography gutterBottom>
                    Offset {OffsetPercentage || "No"} %
                  </Typography>
                  <PrettoSlider
                    valueLabelDisplay="auto"
                    aria-label="pretto slider"
                    value={OffsetPercentage || ""}
                    defaultValue={1}
                    step={0.01}
                    min={0}
                    max={100}
                    onChange={(e) => setOffset(e.target.value)}
                  />
                </Grid>
                {/* panels kw */}
                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
            <TextField
              value={solaWattage}
              required
              fullWidth
              label="Solar Panles W"
              onChange={(e) => setSolarWattage(e.target.value)}
            />
          </Grid> */}
                {/* iis_add_on*/}
                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
            <InputLabel>Add On</InputLabel>
            <Switch
              checked={value.is_add_on}
              onChange={(e) =>
                setValue({
                  ...value,
                  is_add_on: e.target.checked,
                })
              }
              inputProps={{ "aria-label": "controlled" }}
            />
          </Grid> */}
                {/* add_on_id  */}
                {/* {value.is_add_on && (
            <Grid item md={6} sm={9} xs={18} mb={3}>
              <InputLabel>Add On</InputLabel>
              <TextField
                required
                fullWidth
                select
                value={value.add_on_id}
                onChange={(e) =>
                  setValue({
                    ...value,
                    add_on_id: e.target.value,
                  })
                }
              >
                {add_ons.map((serve) => (
                  <MenuItem key={serve.id} value={serve.id}>
                    {serve.title}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )} */}
                {/* number_of_solar_arrays  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    fullWidth
                    label=" Add + or (-) Subtract Panels "
                    type="number"
                    value={value.number_of_solar_arrays}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        number_of_solar_arrays: e.target.value,
                      })
                    }
                  />
                </Grid>
                {/* inverter_type   */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    required
                    select
                    fullWidth
                    label="Inverter Type"
                    value={value.inverter_type}
                    onChange={(e) =>
                      setValue({ ...value, inverter_type: e.target.value })
                    }
                  >
                    {dynamicInverters.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                        {type.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {/* no_of_ft_from_main_service */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    fullWidth
                    label="Number of Feet From Main Service"
                    // type="number"
                    value={value.no_of_ft_from_main_service}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        no_of_ft_from_main_service: Number(e.target.value),
                      })
                    }
                  />
                </Grid>
                {/*  Steep Roof ?*/}
                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={value.is_sun}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_design: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Design Request ?"
                  />
                </Grid> */}
                {/* is_online_monitoring*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Online Monitoring</InputLabel>
                  <Switch
                    checked={value.is_online_monitoring}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_online_monitoring: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>
                {/* System Design */}
                <Grid item xs={18} mb={3}>
                  <h3> System Design</h3>
                  <hr />
                </Grid>
                <Grid item xs={18} mb={3}>
                  <SystemDesign
                    coordinates={coordinates}
                    TotalPanle={TotalPanle}
                    showButton={value.showButton}
                  ></SystemDesign>
                </Grid>
                <Grid item xs={18} mb={3}>
                  <ShowFrameBtn
                    onClick={(e) => {
                      setShowFrame(!showFrame);
                    }}
                    type="button"
                  >
                    Get Solar Data
                  </ShowFrameBtn>
                </Grid>
                {showFrame && (
                  <>
                    {" "}
                    <Grid item xs={18} mb={3}>
                      <DivFrame>
                        <iframe
                          className="frame"
                          id="iframe"
                          scrolling="no"
                          marginwidth="50"
                          src={`https://suncalc.org/#/${singlead?.lat},${singlead?.lng},20/2015.05.11/13:15/324.0/1`}
                          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                          title="description"
                        ></iframe>
                      </DivFrame>
                    </Grid>
                  </>
                )}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={value.is_sun}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_design: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Design Request ?"
                  />
                </Grid>

                {/*End System Desing */}
                <Grid item xs={18} mb={3}>
                  <h3> Premises Information</h3>
                  <hr />
                </Grid>
                {/* Shading D  */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <TextField
                    select
                    required
                    label="Shading"
                    fullWidth
                    value={value.shading}
                    onChange={(e) =>
                      setValue({ ...value, shading: e.target.value })
                    }
                  >
                    {shadings.map((serve) => (
                      <MenuItem key={serve.value} value={serve.value}>
                        {serve.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {value.job_type === "roof_mount" ? (
                  <>
                    {/* Attic*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel> Attic Runs ? </InputLabel>
                      <Switch
                        checked={value.is_attic}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_attic: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Grid>
                  </>
                ) : null}
                {value.is_attic && (
                  <>
                    {/* number_of_conduit_arrays  */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Number of Attic Arrays"
                        value={value.number_of_conduit_arrays}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            number_of_conduit_arrays: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  </>
                )}
                {/* Permitted Structures */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Non-permitted Structures </InputLabel>
                  <Switch
                    checked={value.is_any_non_permitted_structures}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_any_non_permitted_structures: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>
                {/* tree trimming */}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Tree Trimming ? </InputLabel>
                  <Switch
                    checked={value.is_tree_trimming}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_tree_trimming: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>
                {value.is_tree_trimming && (
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <TextField
                      fullWidth
                      label="Number of Trees"
                      value={value.number_of_trees}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          number_of_trees: Number(e.target.value),
                        })
                      }
                    />
                  </Grid>
                )}
                {/* Reverse Tilt */}
                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Reverse Tilt </InputLabel>
                  <Switch
                    checked={value.is_reverse_tilt}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_reverse_tilt: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid> */}
                {/*is_north_faced */}
                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>North Faced</InputLabel>
                  <Switch
                    checked={value.is_north_faced}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_north_faced: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid> */}

                {/* is_online_monitoring*/}
                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Online Monitoring</InputLabel>
                  <Switch
                    checked={value.is_online_monitoring}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_online_monitoring: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid> */}
                {/* digging_slope*/}
                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Digging Slope</InputLabel>
                  <Switch
                    checked={value.digging_slope}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        digging_slope: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid> */}
                {value.job_type === "roof_mount" ? (
                  <>
                    {/* is_standalone_roof_mount*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Standalone Roof Mount</InputLabel>
                      <Switch
                        checked={value.is_standalone_roof_mount}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_standalone_roof_mount: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Grid> */}
                  </>
                ) : null}
                {value.job_type !== "roof_mount" ? (
                  <>
                    {/* is_separate_electrical_meter*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Separate Electrical Meter</InputLabel>
                      <Switch
                        checked={value.is_separate_electrical_meter}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_separate_electrical_meter: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Grid>
                    {/* is_electric_work_currently_on_garage*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Electric Work Currently on Garage</InputLabel>
                      <Switch
                        checked={value.is_electric_work_currently_on_garage}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_electric_work_currently_on_garage:
                              e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Grid>
                    {/* is_sub_panel_on_detached_garage*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Sub Panel On Detached Garage</InputLabel>
                      <Switch
                        checked={value.is_sub_panel_on_detached_garage}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_sub_panel_on_detached_garage: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Grid>
                  </>
                ) : null}
                {/* digging_slope*/}
                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Digging Slope</InputLabel>
                  <Switch
                    checked={value.digging_slope}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        digging_slope: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid> */}
                {/* {value.digging_slope && (
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <TextField
                      fullWidth
                      label="How Many Digging ft"
                      value={value.how_many_digging_ft}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          how_many_digging_ft: Number(e.target.value),
                        })
                      }
                    />
                  </Grid>
                )} */}
                {/*------------- start the Electrical  ------------*/}
                <Grid item xs={18} mb={3}>
                  <h3> Electrical Information</h3>
                  <hr />
                </Grid>
                {/* Existing Electrical Panel*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControl fullWidth required>
                    <InputLabel id="demo-simple-select-label">
                      Existing Electrical Panel
                    </InputLabel>
                    <Select
                      id="demo-simple-select"
                      value={value.existing_electrical_panel}
                      label=" Existing Electrical Panel"
                      onChange={(e) =>
                        setValue({
                          ...value,
                          existing_electrical_panel: e.target.value,
                        })
                      }
                    >
                      {electricalPanels?.map((data) => (
                        <MenuItem key={data.value} value={data.value}>
                          {data.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {/* Existing Electrical Panel*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Upgrade Electrical Panel
                    </InputLabel>
                    <Select
                      id="demo-simple-select"
                      value={value.upgrade_electrical_panel}
                      label=" Upgrade Electrical Panel"
                      onChange={(e) =>
                        setValue({
                          ...value,
                          upgrade_electrical_panel: e.target.value,
                        })
                      }
                    >
                      {UpgradPanles?.map((data) => (
                        <MenuItem key={data.value} value={data.value}>
                          {data.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {/* is_mpu_relocation*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>MPU Relocation</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_mpu_relocation}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_mpu_relocation: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>
                {value.is_mpu_relocation && (
                  <>
                    {/* is_more_than_3ft*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>More than 6ft.</InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_more_than_3ft}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_more_than_3ft: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid>
                  </>
                )}

                {/* number_of_mpu_relocation_foot  */}
                {value.is_more_than_3ft && (
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <TextField
                      fullWidth
                      label="Number of MPU Relocation Foot"
                      value={value.number_of_mpu_relocation_foot}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          number_of_mpu_relocation_foot: Number(e.target.value),
                        })
                      }
                    />
                  </Grid>
                )}
                {/* is_stucco*/}
                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Stucco ?</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_stucco}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_stucco: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid> */}
                {/* mpu*/}
                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Mpu ?</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_mpu_new}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_mpu_new: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid> */}
                {/* is_de_rate*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>DeRate</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_de_rate}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_de_rate: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>

                {/* is_sub_panel*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Sub Panel</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_sub_panel}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_sub_panel: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>

                {/* is_meter_socket*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Meter Socket</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_meter_socket}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_meter_socket: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>

                {/* is_ev_charger*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>EV Charger</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_ev_charger}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_ev_charger: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>

                {/* is_ev_mlo*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>EV MLO</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_ev_mlo}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_ev_mlo: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>
                {/* is_Designated*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Designated plugs</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_designated}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_designated: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>
                {value.is_designated && (
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <TextField
                      fullWidth
                      label="Number of Designated Plugs"
                      // type="number"
                      value={value.number_of_designated_plugs}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          number_of_designated_plugs: Number(e.target.value),
                        })
                      }
                    />
                  </Grid>
                )}

                {/*------------- start the Roofing   ------------*/}
                <Grid item xs={18} mb={3}>
                  <h3> Roofing Information</h3>
                  <hr />
                </Grid>

                {/* is_re_roofing*/}
                <Grid item md={6} sm={9} xs={18} mb={3}>
                  <InputLabel>Roofing ? </InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value.is_roofing}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_roofing: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>

                {value.is_roofing && (
                  <>
                    {/* is_roof_overlay*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Roof Overlay</InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_roof_overlay}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_roof_overlay: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_roof_overlay}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_roof_overlay: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Roof Overlay "
                      />
                    </Grid> */}
                    {/*number_of_re_roof_squares */}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Number of Re-Roof Squares"
                        value={value.number_of_re_roof_squares}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            number_of_re_roof_squares: Number(e.target.value),
                          })
                        }
                      />
                    </Grid> */}

                    {/* is_re_roof_shingle*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Shingle (Re Roof)</InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_re_roof_shingle}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_re_roof_shingle: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}

                    {/* is_roof_relay*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Roof Relay</InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_roof_relay}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_roof_relay: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}

                    {/* is_roof_relay*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>tear off (Shingle)</InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_re_roof_tear_off}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_re_roof_tear_off: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}

                    {/* {value.is_re_roof_tear_off && (
                      <>
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Layers"
                            value={value.number_of_layers}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_layers: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )} */}
                    {/*number_of_layers */}

                    {/* is_re_roof_presidential*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Presidential</InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_re_roof_presidential}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_re_roof_presidential: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}

                    {/* is_re_roof_presidential*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Spanish Tiles</InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_re_roof_spanish_tiles}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_re_roof_spanish_tiles: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}
                    {/* is_re_roof_flat_tiles*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Flat Tiles</InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_re_roof_flat_tiles}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_re_roof_flat_tiles: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}
                    {/* is_re_roof_re_decking*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Re Decking</InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_re_roof_re_decking}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_re_roof_re_decking: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}
                    {/* is_re_roof_fascia_board*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Fascia Board</InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_re_roof_fascia_board}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_re_roof_fascia_board: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}
                    {/* {value.is_re_roof_fascia_board && (
                      <>
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Feet"
                            value={value.number_of_feet}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_feet: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )} */}

                    {/* Rafter Exchange*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Rafter Exchange</InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_rafter_exchange}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_rafter_exchange: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}
                    {/* is_steep*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Steep</InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_steep}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_steep: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}
                    {/* is_air_vent*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Air Vent </InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_air_vent}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_air_vent: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}

                    {/* air_vent*/}
                    {value.is_air_vent && (
                      <>
                        {/* Existing Electrical Panel*/}
                        {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Air Vents
                            </InputLabel>
                            <Select
                              id="demo-simple-select"
                              value={value.air_vent}
                              label=" Air Vents"
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  air_vent: e.target.value,
                                })
                              }
                            >
                              {AirVents?.map((data) => (
                                <MenuItem key={data.value} value={data.value}>
                                  {data.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid> */}
                        {/*number_of_vents */}
                        {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Vents"
                            value={value.number_of_vents}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_vents: Number(e.target.value),
                              })
                            }
                          />
                        </Grid> */}
                      </>
                    )}

                    {/* is_steep_roof*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Steep Roof </InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_steep_roof}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_steep_roof: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}
                    {/* is_double_hand*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Double Hand </InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_double_hand}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_double_hand: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}
                    {/* is_smoke_detectors*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Smoke Detectors</InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_smoke_detectors}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_smoke_detectors: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}
                    {/* {value.is_smoke_detectors && (
                      <>
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Smoke Detectors"
                            value={value.number_of_smoke_detectors}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_smoke_detectors: Number(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )} */}
                    {/* is_warranty_extend*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <InputLabel>Warranty Extend</InputLabel>
                      <span>No</span>
                      <Switch
                        checked={value.is_warranty_extend}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            is_warranty_extend: e.target.checked,
                          })
                        }
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <span>Yes</span>
                    </Grid> */}
                  </>
                )}

                {/*------------- START THE RE ROOFING   ------------*/}

                {value.is_roofing && (
                  <>
                    {/*  Job Type*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Job Type
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          required
                          value={value.roof_job_type_id}
                          label="Job Type"
                          onChange={(e) =>
                            setValue({
                              ...value,
                              roof_job_type_id: e.target.value,
                            })
                          }
                        >
                          {RoofJobsTypes?.map((job) => (
                            <MenuItem value={job.id} key={job.id}>
                              {job.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    {/* content based on Job type */}
                    {value.roof_job_type_id === 1 && (
                      <>
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Tile relay Material
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              required
                              value={value.tile_relay_material_id}
                              label=" Tile relay Material"
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  tile_relay_material_id: e.target.value,
                                })
                              }
                            >
                              {TileRelayMatrial?.map((tile) => (
                                <MenuItem value={tile.id} key={tile.id}>
                                  {tile.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Tile Relay squares "
                            // type="number"
                            value={value.tile_relay_no_of_squares}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                tile_relay_no_of_squares: Number(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Grid>
                        {/* broken */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Broken Tiles "
                            // type="number"
                            value={value.tile_relay_broken}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                tile_relay_broken: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/* Add roof planes for new roof */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  value.is_new_roof_planes_for_tile_relay
                                }
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    is_new_roof_planes_for_tile_relay:
                                      e.target.checked,
                                  })
                                }
                              />
                            }
                            label="Add Roof Planes ? "
                          />
                        </Grid>
                        {/* Add Roof Planes For Tile Relay */}
                        {value.is_new_roof_planes_for_tile_relay === true && (
                          <>
                            <Grid item md={6} sm={9} xs={18} mb={3}>
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  Job Type
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  required
                                  value={
                                    value.add_roof_planes_job_type_id_for_roof_tile
                                  }
                                  label="Job Type"
                                  onChange={(e) =>
                                    setValue({
                                      ...value,
                                      add_roof_planes_job_type_id_for_roof_tile:
                                        e.target.value,
                                    })
                                  }
                                >
                                  {RoofJobsTypes?.map((job) => (
                                    <MenuItem value={job.id} key={job.id}>
                                      {job.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            {value.add_roof_planes_job_type_id_for_roof_tile ===
                              1 && (
                              <>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Tile relay Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.tile_relay_material_id_for_add_roof_planes_tile_relay
                                      }
                                      label=" Tile relay Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          tile_relay_material_id_for_add_roof_planes_tile_relay:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {TileRelayMatrial?.map((tile) => (
                                        <MenuItem value={tile.id} key={tile.id}>
                                          {tile.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Tile Relay squares "
                                    // type="number"
                                    value={
                                      value.tile_relay_no_of_squares_for_add_roof_planes_tile_relay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        tile_relay_no_of_squares_for_add_roof_planes_tile_relay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Broken Tiles "
                                    // type="number"
                                    value={value.roof_planes_tile_relay_broken}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        roof_planes_tile_relay_broken: Number(
                                          e.target.value
                                        ),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                            {value.add_roof_planes_job_type_id_for_roof_tile ===
                              2 && (
                              <>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Roof Overlay Matrials
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.overlay_material_id_for_add_roof_planes_overlay
                                      }
                                      label="Roof Overlay Matrials"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          overlay_material_id_for_add_roof_planes_overlay:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {RoofOverlayMatrials?.map((roofover) => (
                                        <MenuItem
                                          value={roofover.id}
                                          key={roofover.id}
                                        >
                                          {roofover.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                                    <TextField
                                      fullWidth
                                      label="Number of Overlay squares "
                                      // type="number"
                                      value={
                                        value.overlay_no_of_squares_for_add_roof_planes_overlay
                                      }
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          overlay_no_of_squares_for_add_roof_planes_overlay:
                                            Number(e.target.value),
                                        })
                                      }
                                    />
                                  </Grid> */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      New Roof Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.tileRelay_overlay_new_roof_material_id
                                      }
                                      label="New Roof Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          tileRelay_overlay_new_roof_material_id:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {newRooginOverLay?.map((roof) => (
                                        <MenuItem value={roof.id} key={roof.id}>
                                          {roof.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>

                                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                            <TextField
                              fullWidth
                              label="Number of New Squares "
                              // type="number"
                              // disabled
                              value={
                                (value.overlay_number_of_new_squares)
                              }
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  overlay_number_of_new_squares: Number(e.target.value),
                                })
                              }
                            />
                          </Grid> */}

                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Existing squares "
                                    // type="number"
                                    value={
                                      value.TileRelay_overlay_no_of_squares
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        TileRelay_overlay_no_of_squares: Number(
                                          e.target.value
                                        ),
                                      })
                                    }
                                  />
                                </Grid>
                                {/*  Number of Layers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Layers"
                                    // type="number"
                                    value={value.overlay_layers}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_layers: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>

                                {/*  Number of Old Squers */}
                                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                                    <TextField
                                      fullWidth
                                      label="Number of Existing Squares "
                                      // type="number"
                                      value={
                                        value.number_of_planes_squares_for_add_planes_roof_overlay
                                      }
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          number_of_planes_squares_for_add_planes_roof_overlay:
                                            Number(
                                              e.target.value
                                            ),
                                        })
                                      }
                                    />
                                  </Grid> */}
                                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                                    <FormControl fullWidth>
                                      <InputLabel id="demo-simple-select-label">
                                        Existing Roof Material
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={
                                          value.planes_material_id_for_add_planes_roof_overlay
                                        }
                                        label="Existing Roof Material"
                                        onChange={(e) =>
                                          setValue({
                                            ...value,
                                            planes_material_id_for_add_planes_roof_overlay:
                                              e.target.value,
                                          })
                                        }
                                      >
                                        {ExistingRoofing?.map((job) => (
                                          <MenuItem value={job.id} key={job.id}>
                                            {job.name}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </Grid> */}
                                {/*  Roof Pitch Degree. */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Roof Pitch Degree "
                                    value={value.overlay_pitch}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_pitch: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/* Roof Pitch Number of squares */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number Of Steep Squares"
                                    value={value.overlay_steep}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_steep: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                            {value.add_roof_planes_job_type_id_for_roof_tile ===
                              3 && (
                              <>
                                {/*  Number of Layers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Layers"
                                    // type="number"
                                    value={
                                      value.number_of_planes_layers_for_add_roof_planes_tile_relay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_planes_layers_for_add_roof_planes_tile_relay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/*  Number of Old Squers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Old Squares "
                                    // type="number"
                                    value={
                                      value.number_of_planes_squares_for_add_planes_tile_relay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_planes_squares_for_add_planes_tile_relay:
                                          Number(
                                            e.target.value
                                            // , number_of_new_planes_sq: Number(e.target.value)
                                          ),
                                      })
                                    }
                                  />
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Existing Roof Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={
                                        value.planes_material_id_for_add_planes_tile_relay
                                      }
                                      label="Existing Roof Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          planes_material_id_for_add_planes_tile_relay:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {ExistingRoofing?.map((job) => (
                                        <MenuItem value={job.id} key={job.id}>
                                          {job.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                {/*  Roof Pitch Degree. */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Roof Pitch Degree "
                                    value={
                                      value.roof_pitch_degree_for_roof_planes_tile_relay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        roof_pitch_degree_for_roof_planes_tile_relay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/* Roof Pitch Number of squares */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number Of Steep Squares"
                                    value={
                                      value.number_of_steep_sq_for_roof_planes_tile_relay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_steep_sq_for_roof_planes_tile_relay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}

                    {value.roof_job_type_id === 2 && (
                      <>
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Existing Roof Material
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              required
                              value={value.overlay_material_id}
                              // label="Roof Overlay Matrials"
                              label="Existing Roof Material"
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  overlay_material_id: e.target.value,
                                })
                              }
                            >
                              {RoofOverlayMatrials?.map((roofover) => (
                                <MenuItem value={roofover.id} key={roofover.id}>
                                  {roofover.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              New Roof Material
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              required
                              value={value.overlay_new_roof_material_id}
                              label="New Roof Material"
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  overlay_new_roof_material_id: e.target.value,
                                })
                              }
                            >
                              {newRooginOverLay?.map((roof) => (
                                <MenuItem value={roof.id} key={roof.id}>
                                  {roof.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                 <TextField
                   fullWidth
                   label="Number of New Squares "
                   // type="number"
                   // disabled
                   value={
                     (value.overlay_number_of_new_squares)
                   }
                   onChange={(e) =>
                     setValue({
                       ...value,
                       overlay_number_of_new_squares: Number(e.target.value),
                     })
                   }
                 />
               </Grid> */}

                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Existing squares "
                            // type="number"
                            value={value.overlay_no_of_squares}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                overlay_no_of_squares: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/*  Number of Layers */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Layers"
                            // type="number"
                            value={value.overlay_layers}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                overlay_layers: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>

                        {/*  Number of Old Squers */}
                        {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                         <TextField
                           fullWidth
                           label="Number of Existing Squares "
                           // type="number"
                           value={
                             value.number_of_planes_squares_for_add_planes_roof_overlay
                           }
                           onChange={(e) =>
                             setValue({
                               ...value,
                               number_of_planes_squares_for_add_planes_roof_overlay:
                                 Number(
                                   e.target.value
                                 ),
                             })
                           }
                         />
                       </Grid> */}
                        {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                         <FormControl fullWidth>
                           <InputLabel id="demo-simple-select-label">
                             Existing Roof Material
                           </InputLabel>
                           <Select
                             labelId="demo-simple-select-label"
                             id="demo-simple-select"
                             value={
                               value.planes_material_id_for_add_planes_roof_overlay
                             }
                             label="Existing Roof Material"
                             onChange={(e) =>
                               setValue({
                                 ...value,
                                 planes_material_id_for_add_planes_roof_overlay:
                                   e.target.value,
                               })
                             }
                           >
                             {ExistingRoofing?.map((job) => (
                               <MenuItem value={job.id} key={job.id}>
                                 {job.name}
                               </MenuItem>
                             ))}
                           </Select>
                         </FormControl>
                       </Grid> */}
                        {/*  Roof Pitch Degree. */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Roof Pitch Degree "
                            value={value.overlay_pitch}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                overlay_pitch: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/* Roof Pitch Number of squares */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number Of Steep Squares"
                            value={value.overlay_steep}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                overlay_steep: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/* Add roof planes for new roof */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  value.is_new_roof_planes_for_roof_overlay
                                }
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    is_new_roof_planes_for_roof_overlay:
                                      e.target.checked,
                                  })
                                }
                              />
                            }
                            label="Add Roof Planes ? "
                          />
                        </Grid>
                        {value.is_new_roof_planes_for_roof_overlay === true && (
                          <>
                            <Grid item md={6} sm={9} xs={18} mb={3}>
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  Job Type
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  required
                                  value={
                                    value.add_roof_planes_job_type_id_for_roof_overlay
                                  }
                                  label="Job Type"
                                  onChange={(e) =>
                                    setValue({
                                      ...value,
                                      add_roof_planes_job_type_id_for_roof_overlay:
                                        e.target.value,
                                    })
                                  }
                                >
                                  {RoofJobsTypes?.map((job) => (
                                    <MenuItem value={job.id} key={job.id}>
                                      {job.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            {value.add_roof_planes_job_type_id_for_roof_overlay ===
                              1 && (
                              <>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Tile relay Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.tile_relay_material_id_for_add_roof_planes_roof_overlay
                                      }
                                      label=" Tile relay Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          tile_relay_material_id_for_add_roof_planes_roof_overlay:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {TileRelayMatrial?.map((tile) => (
                                        <MenuItem value={tile.id} key={tile.id}>
                                          {tile.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Tile Relay squares "
                                    // type="number"
                                    value={
                                      value.tile_relay_no_of_squares_for_add_roof_planes_roof_overlay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        tile_relay_no_of_squares_for_add_roof_planes_roof_overlay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Broken Tiles "
                                    // type="number"
                                    value={
                                      value.roof_planes_tile_relay_broken_overlay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        roof_planes_tile_relay_broken_overlay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                            {value.add_roof_planes_job_type_id_for_roof_overlay ===
                              2 && (
                              <>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Roof Overlay Matrials
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.overlay_material_id_for_add_roof_planes_overlay_overlay
                                      }
                                      label="Roof Overlay Matrials"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          overlay_material_id_for_add_roof_planes_overlay_overlay:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {RoofOverlayMatrials?.map((roofover) => (
                                        <MenuItem
                                          value={roofover.id}
                                          key={roofover.id}
                                        >
                                          {roofover.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                         <TextField
                           fullWidth
                           label="Number of Overlay squares"
                           // type="number"
                           value={
                             value.overlay_no_of_squares_for_add_roof_planes_overlay_overlay
                           }
                           onChange={(e) =>
                             setValue({
                               ...value,
                               overlay_no_of_squares_for_add_roof_planes_overlay_overlay:
                                 Number(e.target.value),
                             })
                           }
                         />
                       </Grid> */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      New Roof Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.overlay_planes_new_roof_material_id
                                      }
                                      label="New Roof Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          overlay_planes_new_roof_material_id:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {newRooginOverLay?.map((roof) => (
                                        <MenuItem value={roof.id} key={roof.id}>
                                          {roof.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>

                                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                 <TextField
                   fullWidth
                   label="Number of New Squares "
                   // type="number"
                   // disabled
                   value={
                     (value.overlay_number_of_new_squares)
                   }
                   onChange={(e) =>
                     setValue({
                       ...value,
                       overlay_number_of_new_squares: Number(e.target.value),
                     })
                   }
                 />
               </Grid> */}

                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Existing squares "
                                    // type="number"
                                    value={value.overlay_planes_no_of_squares}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_planes_no_of_squares: Number(
                                          e.target.value
                                        ),
                                      })
                                    }
                                  />
                                </Grid>
                                {/*  Number of Layers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Layers"
                                    // type="number"
                                    value={value.overlay_layers}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_layers: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>

                                {/*  Number of Old Squers */}
                                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                         <TextField
                           fullWidth
                           label="Number of Existing Squares "
                           // type="number"
                           value={
                             value.number_of_planes_squares_for_add_planes_roof_overlay
                           }
                           onChange={(e) =>
                             setValue({
                               ...value,
                               number_of_planes_squares_for_add_planes_roof_overlay:
                                 Number(
                                   e.target.value
                                 ),
                             })
                           }
                         />
                       </Grid> */}
                                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                         <FormControl fullWidth>
                           <InputLabel id="demo-simple-select-label">
                             Existing Roof Material
                           </InputLabel>
                           <Select
                             labelId="demo-simple-select-label"
                             id="demo-simple-select"
                             value={
                               value.planes_material_id_for_add_planes_roof_overlay
                             }
                             label="Existing Roof Material"
                             onChange={(e) =>
                               setValue({
                                 ...value,
                                 planes_material_id_for_add_planes_roof_overlay:
                                   e.target.value,
                               })
                             }
                           >
                             {ExistingRoofing?.map((job) => (
                               <MenuItem value={job.id} key={job.id}>
                                 {job.name}
                               </MenuItem>
                             ))}
                           </Select>
                         </FormControl>
                       </Grid> */}
                                {/*  Roof Pitch Degree. */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Roof Pitch Degree "
                                    value={value.overlay_pitch}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_pitch: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/* Roof Pitch Number of squares */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number Of Steep Squares"
                                    value={value.overlay_steep}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_steep: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                            {value.add_roof_planes_job_type_id_for_roof_overlay ===
                              3 && (
                              <>
                                {/*  Number of Layers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Layers"
                                    // type="number"
                                    value={
                                      value.number_of_planes_layers_for_add_roof_planes_roof_overlay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_planes_layers_for_add_roof_planes_roof_overlay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/*  Number of Old Squers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Old Squares "
                                    // type="number"
                                    value={
                                      value.number_of_planes_squares_for_add_planes_roof_overlay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_planes_squares_for_add_planes_roof_overlay:
                                          Number(
                                            e.target.value
                                            // , number_of_new_planes_sq: Number(e.target.value)
                                          ),
                                      })
                                    }
                                  />
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Existing Roof Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={
                                        value.planes_material_id_for_add_planes_roof_overlay
                                      }
                                      label="Existing Roof Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          planes_material_id_for_add_planes_roof_overlay:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {ExistingRoofing?.map((job) => (
                                        <MenuItem value={job.id} key={job.id}>
                                          {job.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                {/*  Roof Pitch Degree. */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Roof Pitch Degree "
                                    value={
                                      value.roof_pitch_degree_for_roof_planes_roof_overlay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        roof_pitch_degree_for_roof_planes_roof_overlay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/* Roof Pitch Number of squares */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number Of Steep Squares"
                                    value={
                                      value.number_of_steep_sq_for_roof_planes_roof_overlay
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_steep_sq_for_roof_planes_roof_overlay:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                          </>
                        )}
                        {/* <Grid item md={18} sm={18} xs={18} mb={3}>
                 New Roofing try
                 <hr></hr>
               </Grid> */}

                        {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                 <FormControl fullWidth>
                   <InputLabel id="demo-simple-select-label">
                     New Roof Material
                   </InputLabel>
                   <Select
                     labelId="demo-simple-select-label"
                     id="demo-simple-select"
                     required
                     value={value.overlay_new_roof_material_id}
                     label="New Roof Material"
                     onChange={(e) =>
                       setValue({
                         ...value,
                         overlay_new_roof_material_id: e.target.value,
                       })
                     }
                   >
                     {newRooginOverLay?.map((roof) => (
                       <MenuItem value={roof.id} key={roof.id}>
                         {roof.name}
                       </MenuItem>
                     ))}
                   </Select>
                 </FormControl>
               </Grid>

               <Grid item md={6} sm={9} xs={18} mb={3}>
                 <TextField
                   fullWidth
                   label="Number of Squares "
                   // type="number"
                   // disabled
                   value={
                     (value.overlay_number_of_new_squares)
                   }
                   onChange={(e) =>
                     setValue({
                       ...value,
                       overlay_number_of_new_squares: Number(e.target.value),
                     })
                   }
                 />
               </Grid> */}

                        {/* Add Roof Planes For Roof Overlay */}
                      </>
                    )}
                    {value.roof_job_type_id === 3 && (
                      <>
                        {/*  Existing Roof*/}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Existing Roof Material
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={value.existing_roof_material_id}
                              label="Existing Roof Material"
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  existing_roof_material_id: e.target.value,
                                })
                              }
                            >
                              {ExistingRoofing?.map((job) => (
                                <MenuItem value={job.id} key={job.id}>
                                  {job.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        {/*  Number of Layers */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Layers  "
                            // type="number"
                            value={value.number_of_old_layers}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_old_layers: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/*  Number of Old Squers */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Existing Squares "
                            // type="number"
                            value={value.number_of_old_squares}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_old_squares: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/*  Roof Pitch Degree. */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Roof Pitch Degree "
                            value={value.roof_pitch_degree}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                roof_pitch_degree: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/* Roof Pitch Number of squares */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number Of Steep Squares"
                            value={value.number_of_steep_sq}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_steep_sq: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/*  Steep Roof ?*/}
                        {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={value.is_steep_pitch}
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  is_steep_pitch: e.target.checked,
                                })
                              }
                            />
                          }
                          label="Roof Pitch ?"
                        />
                      </Grid> */}
                        {/* {value.is_steep_pitch && (
                        <>
                           Roof Pitch Degree.
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            <TextField
                              fullWidth
                              label="Roof Pitch Degree "
                              value={value.roof_pitch_degree}
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  roof_pitch_degree: Number(e.target.value),
                                })
                              }
                            />
                          </Grid>
                          Roof Pitch Number of squares
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            <TextField
                              fullWidth
                              label="Number Of Steep Squares"
                              value={value.number_of_steep_sq}
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  number_of_steep_sq: Number(e.target.value),
                                })
                              }
                            />
                          </Grid>
                        </>
                      )} */}
                        {/* is roof planes for re roofing */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={value.is_roof_planes}
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    is_roof_planes: e.target.checked,
                                  })
                                }
                              />
                            }
                            label="Add Roof Planes ? "
                          />
                        </Grid>

                        {value.is_roof_planes && (
                          <>
                            {/*  Job Type for roof planes*/}
                            <Grid item md={6} sm={9} xs={18} mb={3}>
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  Job Type
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  required
                                  value={value.roof_job_type_id_roof_planes}
                                  label="Job Type"
                                  onChange={(e) =>
                                    setValue({
                                      ...value,
                                      roof_job_type_id_roof_planes:
                                        e.target.value,
                                    })
                                  }
                                >
                                  {RoofJobsTypes?.map((job) => (
                                    <MenuItem value={job.id} key={job.id}>
                                      {job.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            {value.roof_job_type_id_roof_planes === 1 && (
                              <>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Tile relay Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.tile_relay_material_id_for_add_roof_planes
                                      }
                                      label=" Tile relay Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          tile_relay_material_id_for_add_roof_planes:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {TileRelayMatrial?.map((tile) => (
                                        <MenuItem value={tile.id} key={tile.id}>
                                          {tile.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Tile Relay squares "
                                    // type="number"
                                    value={
                                      value.tile_relay_no_of_squares_for_add_roof_planes
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        tile_relay_no_of_squares_for_add_roof_planes:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Broken Tiles "
                                    // type="number"
                                    value={
                                      value.roof_planes_tile_relay_broken_reroof
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        roof_planes_tile_relay_broken_reroof:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                            {value.roof_job_type_id_roof_planes === 2 && (
                              <>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Roof Overlay Matrials
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.overlay_material_id_for_add_roof_planes
                                      }
                                      label="Roof Overlay Matrials"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          overlay_material_id_for_add_roof_planes:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {RoofOverlayMatrials?.map((roofover) => (
                                        <MenuItem
                                          value={roofover.id}
                                          key={roofover.id}
                                        >
                                          {roofover.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Overlay squares "
                                    // type="number"
                                    value={
                                      value.overlay_no_of_squares_for_add_roof_planes
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_no_of_squares_for_add_roof_planes:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      New Roof Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.reroof_overlay_new_roof_material_id
                                      }
                                      label="New Roof Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          reroof_overlay_new_roof_material_id:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {newRooginOverLay?.map((roof) => (
                                        <MenuItem value={roof.id} key={roof.id}>
                                          {roof.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>

                                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                        <TextField
                          fullWidth
                          label="Number of New Squares "
                          // type="number"
                          // disabled
                          value={
                            (value.overlay_number_of_new_squares)
                          }
                          onChange={(e) =>
                            setValue({
                              ...value,
                              overlay_number_of_new_squares: Number(e.target.value),
                            })
                          }
                        />
                      </Grid> */}

                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Existing squares "
                                    // type="number"
                                    value={value.reroof_overlay_no_of_squares}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        reroof_overlay_no_of_squares: Number(
                                          e.target.value
                                        ),
                                      })
                                    }
                                  />
                                </Grid>
                                {/*  Number of Layers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Layers"
                                    // type="number"
                                    value={value.overlay_layers}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_layers: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>

                                {/*  Number of Old Squers */}
                                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                                <TextField
                                  fullWidth
                                  label="Number of Existing Squares "
                                  // type="number"
                                  value={
                                    value.number_of_planes_squares_for_add_planes_roof_overlay
                                  }
                                  onChange={(e) =>
                                    setValue({
                                      ...value,
                                      number_of_planes_squares_for_add_planes_roof_overlay:
                                        Number(
                                          e.target.value
                                        ),
                                    })
                                  }
                                />
                              </Grid> */}
                                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                                <FormControl fullWidth>
                                  <InputLabel id="demo-simple-select-label">
                                    Existing Roof Material
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={
                                      value.planes_material_id_for_add_planes_roof_overlay
                                    }
                                    label="Existing Roof Material"
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        planes_material_id_for_add_planes_roof_overlay:
                                          e.target.value,
                                      })
                                    }
                                  >
                                    {ExistingRoofing?.map((job) => (
                                      <MenuItem value={job.id} key={job.id}>
                                        {job.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid> */}
                                {/*  Roof Pitch Degree. */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Roof Pitch Degree "
                                    value={value.overlay_pitch}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_pitch: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/* Roof Pitch Number of squares */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number Of Steep Squares"
                                    value={value.overlay_steep}
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        overlay_steep: Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                            {value.roof_job_type_id_roof_planes === 3 && (
                              <>
                                {/*  Number of Layers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Layers  "
                                    // type="number"
                                    value={
                                      value.number_of_planes_layers_for_add_roof_planes
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_planes_layers_for_add_roof_planes:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/*  Number of Old Squers */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number of Old Squares "
                                    // type="number"
                                    value={
                                      value.number_of_planes_squares_for_add_planes
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_planes_squares_for_add_planes:
                                          Number(
                                            e.target.value
                                            // , number_of_new_planes_sq: Number(e.target.value)
                                          ),
                                      })
                                    }
                                  />
                                </Grid>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Existing Roof Material
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={
                                        value.planes_material_id_for_add_planes
                                      }
                                      label="Existing Roof Material"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          planes_material_id_for_add_planes:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {ExistingRoofing?.map((job) => (
                                        <MenuItem value={job.id} key={job.id}>
                                          {job.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                {/*  Roof Pitch Degree. */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Roof Pitch Degree "
                                    value={
                                      value.roof_pitch_degree_for_roof_planes
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        roof_pitch_degree_for_roof_planes:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                                {/* Roof Pitch Number of squares */}
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <TextField
                                    fullWidth
                                    label="Number Of Steep Squares"
                                    value={
                                      value.number_of_steep_sq_for_roof_planes
                                    }
                                    onChange={(e) =>
                                      setValue({
                                        ...value,
                                        number_of_steep_sq_for_roof_planes:
                                          Number(e.target.value),
                                      })
                                    }
                                  />
                                </Grid>
                              </>
                            )}

                            {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                            <InputLabel>Add Job Type ? </InputLabel>
                            <span>No</span>
                            <Switch
                              checked={value.add_job_type_for_new_roof}
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  add_job_type_for_new_roof: e.target.checked,
                                })
                              }
                              inputProps={{ "aria-label": "controlled" }}
                            />
                            <span>Yes</span>
                          </Grid> */}
                            {value.add_job_type_for_new_roof === true && (
                              <>
                                <Grid item md={6} sm={9} xs={18} mb={3}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      Job Type
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      required
                                      value={
                                        value.roof_job_type_id_for_Tilerelay
                                      }
                                      label="Job Type"
                                      onChange={(e) =>
                                        setValue({
                                          ...value,
                                          roof_job_type_id_for_Tilerelay:
                                            e.target.value,
                                        })
                                      }
                                    >
                                      {RoofJobsTypes?.map((job) => (
                                        <MenuItem value={job.id} key={job.id}>
                                          {job.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                                <TextField
                                  fullWidth
                                  label="Number of Old Squares "
                                  // type="number"
                                  value={value.number_of_old_squares_new_job_type}
                                  onChange={(e) =>
                                    setValue({
                                      ...value,
                                      number_of_old_squares_new_job_type: Number(e.target.value)
                                    })


                                  }
                                />
                              </Grid> */}
                              </>
                            )}
                          </>
                        )}
                        {/* End of Try */}

                        <Grid item xs={18} mb={3}>
                          <h5> New Roofing </h5>
                        </Grid>

                        {/*  Existing Roof*/}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              New Roof Material
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              required
                              value={value.new_roof_material_id}
                              label="New Roof Material"
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  new_roof_material_id: e.target.value,
                                })
                              }
                            >
                              {NewRoofJobTypes?.map((roof) => (
                                <MenuItem value={roof.id} key={roof.id}>
                                  {roof.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        {/*  Number of new Squers */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Squares "
                            // type="number"
                            // disabled
                            value={
                              (value.number_of_new_squares =
                                value.number_of_old_squares)
                            }
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_new_squares: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>

                        {value.new_roof_material_id === 1 && (
                          <>
                            {/*  color of shigle  Roof*/}
                            {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                            <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-label">
                                color Roof
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={value.color_id}
                                label="Existing Roof "
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    color_id: e.target.value,
                                  })
                                }
                              >
                                {colors?.map((color) => (
                                  <MenuItem value={color.id} key={color.id}>
                                    {color.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid> */}
                            {/* start a color dropdown */}
                            <Grid item md={6} sm={9} xs={18} mb={3}>
                              <ColorRoofing>
                                <div className="select-box">
                                  <div
                                    className="select-box__current"
                                    tabIndex="1"
                                  >
                                    <div class="select-box__value">
                                      <input
                                        type="radio"
                                        class="select-box__input show"
                                        // id="0q"
                                        // value="1q"
                                        name="color"
                                        // checked
                                      />
                                      <p class="select-box__input-text work">
                                        Choose Color{" "}
                                      </p>
                                    </div>
                                    {colors?.map((color) => (
                                      <div
                                        className="select-box__value"
                                        key={color.id}
                                      >
                                        <input
                                          type="radio"
                                          className="select-box__input"
                                          id={color.id}
                                          value={color.id}
                                          name="color"
                                          // checked={color.id}
                                          onChange={(e) =>
                                            setValue({
                                              ...value,
                                              color_id: e.target.value,
                                            })
                                          }
                                        />
                                        <p
                                          className="select-box__input-text "
                                          style={{
                                            background: `url(${color.image_path})`,
                                          }}
                                        >
                                          {color.name}
                                        </p>
                                      </div>
                                    ))}
                                  </div>
                                  <ul class="select-box__list">
                                    {colors?.map((color) => (
                                      <li key={color.id}>
                                        <label
                                          class="select-box__option "
                                          htmlFor={color.id}
                                          style={{
                                            background: `url(${color.image_path})`,
                                          }}
                                        >
                                          {color.name}
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </ColorRoofing>
                            </Grid>

                            {/*  Number of Old Squers */}
                            {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                            <TextField
                              fullWidth
                              label="New Material Cost per Sq. "
                              // type="number"
                              value={value.new_color_cost}
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  new_color_cost: Number(e.target.value),
                                })
                              }
                            />
                          </Grid> */}
                          </>
                        )}
                        {/*  Number of new Squers */}
                        <Grid
                          item
                          md={6}
                          sm={9}
                          xs={18}
                          mb={3}
                          style={{ display: "none" }}
                        >
                          <TextField
                            fullWidth
                            label="Number of Squares "
                            // type="number"
                            disabled
                            value={value.number_of_old_squares}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_new_squares: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                        {/* Add roof planes for new roof */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={value.is_new_roof_planes}
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    is_new_roof_planes: e.target.checked,
                                  })
                                }
                              />
                            }
                            label="Add Roof Planes  ? "
                          />
                        </Grid>

                        {value.is_new_roof_planes && (
                          <>
                            {/*  Number of Old Squers */}
                            <Grid item md={6} sm={9} xs={18} mb={3}>
                              <TextField
                                fullWidth
                                label="Number of new Squares "
                                // type="number"
                                // disabled
                                value={value.number_of_planes_squares}
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    number_of_planes_squares: Number(
                                      e.target.value
                                    ),
                                  })
                                }
                              />
                            </Grid>
                            {/*  Number of Layers */}
                            {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                            <TextField
                              fullWidth
                              label="Number of Layers  "
                              // type="number"
                              value={value.number_of_planes_layers}
                              onChange={(e) =>
                                setValue({
                                  ...value,
                                  number_of_planes_layers: Number(e.target.value),
                                })
                              }
                            />
                          </Grid> */}
                            <Grid item md={6} sm={9} xs={18} mb={3}>
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  New Roof Material
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  required
                                  value={value.new_planes_material_id}
                                  label="New Roof Material"
                                  onChange={(e) =>
                                    setValue({
                                      ...value,
                                      new_planes_material_id: e.target.value,
                                    })
                                  }
                                >
                                  {NewRoofJobTypes?.map((roof) => (
                                    <MenuItem value={roof.id} key={roof.id}>
                                      {roof.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                          </>
                        )}
                        {/*  Number of Layers */}
                        {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                        <TextField
                          fullWidth
                          label="Number of Layers  "
                          // type="number"
                          value={value.number_of_new_layers}
                          onChange={(e) =>
                            setValue({
                              ...value,
                              number_of_new_layers: Number(e.target.value),
                            })
                          }
                        />
                      </Grid> */}
                      </>
                    )}

                    <Grid item xs={18} mb={3}>
                      <hr />
                    </Grid>

                    {/*  Redecking*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_redecking}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_redecking: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Redecking ?"
                      />
                    </Grid>
                    {value.is_redecking && (
                      <>
                        {/*  Number of Redecking Squares */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Redecking Squares  "
                            // type="number"
                            value={value.number_of_redecking_squares}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_redecking_squares: Number(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  Rafter Exchage */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_rafter}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_rafter: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Rafter Exchage ?"
                      />
                    </Grid>
                    {value.is_rafter && (
                      <>
                        {/*  Number of Rafter ft. */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Rafter ft. "
                            // type="number"
                            value={value.number_of_rafter_ft}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_rafter_ft: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  Is Light House ?  */}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_sky_light}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_sky_light: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Sky Light?"
                      />
                    </Grid> */}
                    {/*  Fascia Replace Board ?  */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_fascia}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_fascia: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Fascia Replace Board ?"
                      />
                    </Grid>
                    {value.is_fascia && (
                      <>
                        {/*  Number of Fasciz ft. */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Fasciz ft. "
                            // type="number"
                            value={value.number_of_fascia_ft}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_fascia_ft: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  Steep Roof ?*/}
                    {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_steep_pitch}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_steep_pitch: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Roof Pitch ?"
                      />
                    </Grid> */}
                    {/*  Roof Pitch Degree. */}
                    {/* {value.is_steep_pitch && (
                      <>
                       
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Roof Pitch Degree "
                            value={value.roof_pitch_degree}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                roof_pitch_degree: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )} */}

                    <Grid item xs={18} mb={3}>
                      <hr />
                    </Grid>
                    {/*  HVAC Unit on Roof ?*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_hvac_replace}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_hvac_replace: e.target.checked,
                              })
                            }
                          />
                        }
                        label="HVAC Unit on Roof ?"
                      />
                    </Grid>
                    {value.is_hvac_replace && (
                      <>
                        {/*  Number of HVAC */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of HVAC Units"
                            value={value.number_of_hvac_units}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_hvac_units: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  Air Vent Replacement ?*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_air_vent_replacement}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_air_vent_replacement: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Air Vent Replacement ?"
                      />
                    </Grid>
                    {value.is_air_vent_replacement && (
                      <>
                        {/*  Number of Vents to Be Replaced */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Vents to Be Replaced "
                            value={value.number_of_replaced_vents}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_replaced_vents: Number(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  New Air Vent ?*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_new_vent}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_new_vent: e.target.checked,
                              })
                            }
                          />
                        }
                        label="New Air Vent ?"
                      />
                    </Grid>
                    {value.is_new_vent && (
                      <>
                        {/*  Number of New Vents. */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of New Vents "
                            value={value.number_of_new_vents}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_new_vents: Number(e.target.value),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  Smoke Monitors ? */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_smoke_monitors}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_smoke_monitors: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Smoke Monitors ?"
                      />
                    </Grid>
                    {value.is_smoke_monitors && (
                      <>
                        {/*  Number of Smoke Delectors. */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Smoke Delectors"
                            value={value.number_of_smoke_monitors}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_smoke_monitors: Number(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  Double Hand ?*/}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_double_hands}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_double_hands: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Double Hand ?"
                      />
                    </Grid>
                    {value.is_double_hands && (
                      <>
                        {/*  Number of Squares  */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Squares "
                            value={value.number_of_double_hand_squares}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_double_hand_squares: Number(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  Carbon Monoxide Monitors ? */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={value.is_monoxide_detectors}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                is_monoxide_detectors: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Carbon Monoxide Monitors ?"
                      />
                    </Grid>
                    {value.is_monoxide_detectors && (
                      <>
                        {/*  Number of Carbon Delectors. */}
                        <Grid item md={6} sm={9} xs={18} mb={3}>
                          <TextField
                            fullWidth
                            label="Number of Carbon Delectors  "
                            value={value.number_of_monoxide_detectors}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                number_of_monoxide_detectors: Number(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Grid>
                      </>
                    )}

                    {/*  Added Roof Cost  */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Added Roof Cost "
                        value={value.added_cost}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            added_cost: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>
                    {/* Description of Added Work */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Description of Added Work"
                        value={value.add_work_description}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            add_work_description: e.target.value,
                          })
                        }
                      />
                    </Grid>
                    {/* Roof Royalties */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Roof Royalties"
                        value={value.royalties_cost}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            royalties_cost: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>

                    {/*Notes */}
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      {/* <span>Notes</span> */}
                      <TextField
                        fullWidth
                        label="Notes"
                        value={value.notes}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            notes: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  </>
                )}

                {/*------------- E N D THE RE ROOFING   ------------*/}

                {/*------------- start the Electrical  ------------*/}
                <Grid item xs={18}>
                  <div className="hvac">
                    <h3> HVAC Information</h3>{" "}
                    {/* <Button
                      onClick={handleOpenHvac}
                      className="btn"
                      // style={{ color: "#4acfac" }}
                    >
                      Add Hvac
                    </Button> */}
                  </div>
                  <hr />
                </Grid>
                <Grid item xs={18}>
                  <Button
                    onClick={handleOpenHvac}
                    className="btn"
                    endIcon={<AddIcon></AddIcon>}
                    // style={{ color: "#4acfac" }}
                  >
                    Add Hvac
                  </Button>
                </Grid>
                {/* <Grid container columns={18}> */}
                {/* {hvacs.length > 0 && ( */}

                {/* )} */}

                {hvacs.length > 0 && (
                  <Grid item lg={18} sm={18} xs={18}>
                    <TableContainer>
                      <Table>
                        <thead>
                          <tr>
                            <th>Index</th>
                            <th>hvac location</th>
                            <th>number hvac ft</th>
                            <th>hvac horse power</th>
                            {/* <th>is ducting</th> */}
                            {/* <th>number of ducting run</th> */}
                            {/* <th>is led lighting</th> */}
                            {/* <th>number of led lighting</th> */}
                            {/* <th>is energy efficient plugs</th> */}
                            {/* <th>number of efficient plugs</th> */}
                            {/* <th>is solar lip</th> */}
                            {/* <th>number of solar lip</th> */}
                            {/* <th>is bird netting</th> */}
                            {/* <th>inumber of bird netting</th> */}
                            {/* <th>is warranty package</th> */}
                            {/* <th>warranty</th> */}
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {hvacs.map((e, i) => {
                            return (
                              <tr key={i}>
                                <td>{++i}</td>
                                <td>{e.hvac_location}</td>
                                <td>{e.number_hvac_ft}</td>
                                <td>{e.hvac_horse_power}</td>
                                {/* <td>{e.is_ducting?.toString()}</td>
                                  <td>{e.number_of_ducting_run}</td>
                                  <td>{e.is_led_lighting?.toString()}</td>
                                  <td>{e.number_of_led_lighting}</td>
                                  <td>{e.is_energy_efficient_plugs?.toString()}</td>
                                  <td>{e.number_of_efficient_plugs}</td>
                                  <td>{e.is_solar_lip?.toString()}</td>
                                  <td>{e.number_of_solar_lip}</td>
                                  <td>{e.is_bird_netting?.toString()}</td>
                                  <td>{e.number_of_bird_netting}</td>
                                  <td>{e.is_warranty_package?.toString()}</td>
                                  <td>{e.warranty?.toString()}</td> */}
                                <td>
                                  <button
                                    style={{
                                      background: "none",
                                      color: "red",
                                      border: "none",
                                      cursor: "pointer",
                                    }}
                                    type="button"
                                    onClick={() => {
                                      deleteFromLicenses(e.id);
                                    }}
                                  >
                                    <DeleteIcon></DeleteIcon>
                                    {/* <DeleteIcon></DeleteIcon> */}
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </TableContainer>
                  </Grid>
                )}
                {/* </Grid> */}

                {/* <Grid item lg={18} md={18} sm={18} xs={18}>
                  <div className="hvac">
                    <p>Opportunity</p>
                    <div
                      style={{ position: "absolute", right: "3rem", top: "0" }}
                    >
                      {" "}
                      <button>Edit Solution</button>
                    </div>
                  </div>
                </Grid> */}

                {/* is_warranty_extend*/}

                {/*------------- start the Electrical  ------------*/}
                <Grid item xs={18}>
                  <div className="hvac">
                    <h3>Battery Information</h3>
                    {/* <Button
                      style={{ color: "#4acfac" }}
                      onClick={handleOpenBattery}
                      className="btn"
                    >
                      Add Battery
                    </Button> */}
                  </div>
                  <hr />
                </Grid>
                <Grid item xs={18}>
                  <Button
                    onClick={handleOpenBattery}
                    className="btn"
                    endIcon={<AddIcon></AddIcon>}
                  >
                    Add Battery
                  </Button>
                </Grid>
                {/* <Grid container columns={18}> */}
                {batteries.length > 0 && (
                  <Grid item lg={18} sm={18} xs={18}>
                    <TableContainer>
                      <Table>
                        <thead>
                          <tr>
                            <th>Index</th>
                            <th>Battery Power</th>
                            <th>Number of batteries</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {batteries.map((e, i) => {
                            return (
                              <tr key={i}>
                                <td>{++i}</td>
                                <td>{e.battery_power}</td>
                                <td>{e.number_of_batteries}</td>
                                <td>
                                  <button
                                    style={{
                                      background: "none",
                                      color: "red",
                                      border: "none",
                                      cursor: "pointer",
                                    }}
                                    type="button"
                                    onClick={() => {
                                      deleteFromBatteries(e.id);
                                    }}
                                  >
                                    <DeleteIcon></DeleteIcon>
                                    {/* <DeleteIcon></DeleteIcon> */}
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </TableContainer>
                  </Grid>
                )}

                {/* Generators */}
                <Grid item xs={18}>
                  <div className="hvac">
                    <h3>Generator Information</h3>
                  </div>
                  <hr />
                </Grid>
                <Grid item xs={18}>
                  <Button
                    onClick={handleOpenGenerator}
                    className="btn"
                    endIcon={<AddIcon></AddIcon>}
                  >
                    Add Generator
                  </Button>
                </Grid>
                {/* <Grid container columns={18}> */}
                {generators.length > 0 && (
                  <Grid item lg={18} sm={18} xs={18}>
                    <TableContainer>
                      <Table>
                        <thead>
                          <tr>
                            <th>Index</th>
                            <th>Generator Power</th>
                            <th>Number of Generators</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {generators.map((e, i) => {
                            return (
                              <tr key={i}>
                                <td>{++i}</td>
                                <td>{e.generator_power}</td>
                                <td>{e.number_of_generators}</td>
                                <td>
                                  <button
                                    style={{
                                      background: "none",
                                      color: "red",
                                      border: "none",
                                      cursor: "pointer",
                                    }}
                                    type="button"
                                    onClick={() => {
                                      deleteFromGenerators(e.id);
                                    }}
                                  >
                                    <DeleteIcon></DeleteIcon>
                                    {/* <DeleteIcon></DeleteIcon> */}
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </TableContainer>
                  </Grid>
                )}
                <Grid item xs={18} mb={3}>
                  <h3>Addons </h3>
                  <hr />
                </Grid>
                <>
                  {/* is_ducting*/}

                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel>Ducting</InputLabel>
                    <span>No</span>
                    <Switch
                      checked={value?.is_ducting}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          is_ducting: e.target.checked,
                        })
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <span>Yes</span>
                  </Grid>
                  {/* number_of_ducting_run  */}
                  {value?.is_ducting && (
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Number of Ducting Run"
                        value={singleHvac?.number_of_ducting_run}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            number_of_ducting_run: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>
                  )}

                  {/* is_led_lighting*/}
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel>Led Lighting</InputLabel>
                    <span>No</span>
                    <Switch
                      checked={value?.is_led_lighting}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          is_led_lighting: e.target.checked,
                        })
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <span>Yes</span>
                  </Grid>
                  {/* number_of_ducting_run  */}
                  {value?.is_led_lighting && (
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Number of Led Lighting"
                        value={value?.number_of_led_lighting}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            number_of_led_lighting: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>
                  )}
                  {/* is_energy_efficient_plugs*/}
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel>Energy Efficient Plugs</InputLabel>
                    <span>No</span>
                    <Switch
                      checked={value?.is_energy_efficient_plugs}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          is_energy_efficient_plugs: e.target.checked,
                        })
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <span>Yes</span>
                  </Grid>
                  {/* number_of_ducting_run  */}
                  {value?.is_energy_efficient_plugs && (
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Number of Efficient Plugs"
                        value={value?.number_of_efficient_plugs}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            number_of_efficient_plugs: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>
                  )}
                  {/* is_solar_lip*/}
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel>Solar Lip</InputLabel>
                    <span>No</span>
                    <Switch
                      checked={value?.is_solar_lip}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          is_solar_lip: e.target.checked,
                        })
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <span>Yes</span>
                  </Grid>
                  {/* number_of_solar_lip  */}
                  {value?.is_solar_lip && (
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Number of Solar Lip"
                        value={value?.number_of_solar_lip}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            number_of_solar_lip: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>
                  )}
                  {/* is_bird_netting*/}
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel>Bird Netting</InputLabel>
                    <span>No</span>
                    <Switch
                      checked={value?.is_bird_netting}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          is_bird_netting: e.target.checked,
                        })
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <span>Yes</span>
                  </Grid>
                  {/* number_of_solar_lip  */}
                  {value?.is_bird_netting && (
                    <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Number of Bird Netting"
                        value={value?.number_of_bird_netting}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            number_of_bird_netting: Number(e.target.value),
                          })
                        }
                      />
                    </Grid>
                  )}

                  {/* is_warranty_package*/}
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel>is_warranty_package</InputLabel>
                    <span>No</span>
                    <Switch
                      checked={value?.is_warranty_package}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          is_warranty_package: e.target.checked,
                        })
                      }
                      inputProps={{ "aria-label": "controlled" }}
                    />
                    <span>Yes</span>
                  </Grid>

                  {/* warranty  */}
                  {value?.is_warranty_package && (
                    <>
                      <Grid item md={6} sm={9} xs={18} mb={3}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Warranty
                          </InputLabel>
                          <Select
                            id="demo-simple-select"
                            value={value?.warranty}
                            label="battery_power"
                            onChange={(e) =>
                              setValue({
                                ...value,
                                warranty: e.target.value,
                              })
                            }
                          >
                            {Warranties?.map((data) => (
                              <MenuItem key={data.value} value={data.value}>
                                {data.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </>
                  )}
                </>
                {/* </Grid> */}
                {/* ***************************************** */}
                <Grid item xs={18} mb={3}>
                  <h3>Internal overhead </h3>
                  <hr />
                </Grid>

                {/* ***************************************** */}
                <Grid item xs={18}>
                  <TextField
                    fullWidth
                    label="Internal overhead"
                    value={value.royalties}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        royalties: e.target.value,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={18}>
                  <InputLabel>Discount</InputLabel>
                  <span>No</span>
                  <Switch
                    checked={value?.is_discount}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_discount: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid>
                {value?.is_discount ? (
                  <>
                    <Grid item xs={18} md={6}>
                      <FormControl>
                        <FormLabel id="demo-row-radio-buttons-group-label">
                          Discount type
                        </FormLabel>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={value?.discount_type}
                          onChange={handleChange}
                        >
                          <FormControlLabel
                            value="percentage"
                            control={<Radio />}
                            label="Percentage"
                          />
                          <FormControlLabel
                            value="fixed"
                            control={<Radio />}
                            label="Fixed amount"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    {value?.discount_type === "percentage" ? (
                      <>
                        {" "}
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            label="Percent"
                            value={value.discount_percent}
                            onChange={(e) => {
                              if (
                                e.target.value >= 0 &&
                                e.target.value <= 100
                              ) {
                                setValue({
                                  ...value,
                                  discount_percent: e.target.value,
                                });
                              }
                            }}
                            type="number"
                          />
                        </Grid>
                      </>
                    ) : (
                      <></>
                    )}
                    {value?.discount_type === "fixed" ? (
                      <>
                        {" "}
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            label="Fixed amount"
                            value={value.discount_amount}
                            onChange={(e) => {
                              if (e.target.value >= 0) {
                                setValue({
                                  ...value,
                                  discount_amount: e.target.value,
                                });
                              }
                            }}
                            type="number"
                          />
                        </Grid>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}

                {/* <Grid item xs={18} mb={3}>
                  <h3>Extra Fees </h3>
                  <hr />
                </Grid>
                <Grid item xs={18}>
                  <TextField
                    fullWidth
                    label="Extra Fees"
                    value={value.extra_cost}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        extra_cost: e.target.value,
                      })
                    }
                  />
                </Grid> */}
                <Grid item xs={18} mb={3}>
                  <h3>Notes </h3>
                  <hr />
                </Grid>
                <Grid item xs={18}>
                  <TextareaAutosize
                    fullWidth
                    style={{
                      minWidth: "100%",
                      fontSize: "19px",
                      maxWidth: "100%",
                    }}
                    minRows={5}
                    maxRows={6}
                    label="Notes"
                    placeholder="Type Your Notes"
                    value={value.solar_notes}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        solar_notes: e.target.value,
                      })
                    }
                  />
                </Grid>
                {/* <Grid item xs={18} mb={3}>
            <h3>Contractor Information </h3>
            <hr />
          </Grid>

          <Grid item xs={18}>
            <ContractorStyled>
              <div className="contactorData">
                <h3 className="title">
                  <AccountCircle /> Name :
                </h3>
                <h4 className="value">
                  {utilContractors ? utilContractors[0]?.name : ""}
                </h4>
              </div>
              <div className="contactorData">
                <h3 className="title">
                  <CreditCard /> License No :
                </h3>
                <h4 className="value">
                  {utilContractors ? utilContractors[0]?.license : ""}
                </h4>
              </div>
              <div className="contactorData">
                <h3 className="title">
                  <MyLocation /> Adress :
                </h3>
                <h4 className="value">
                  {utilContractors ? utilContractors[0]?.address : ""}
                </h4>
              </div>
              <div className="contactorData">
                <h3 className="title">
                  <LocationCity /> Company :
                </h3>
                <h4 className="value">
                  {utilContractors ? utilContractors[0]?.entity : ""}
                </h4>
              </div>
            </ContractorStyled>
          </Grid> */}
                {/* is_finance*/}
                <Grid item md={9} sm={9} xs={18} mb={3}>
                  <InputLabel>Cash / Finance</InputLabel>
                  <Switch
                    checked={value.is_finance}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_finance: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>
                {/* <Grid item md={9} sm={9} xs={18} mb={3}>
                  <InputLabel>Add 30 years Insurance</InputLabel>
                  <span>NO</span>
                  <Switch
                    checked={value.is_insurance}
                    onChange={(e) =>
                      setValue({
                        ...value,
                        is_insurance: e.target.checked,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span>Yes</span>
                </Grid> */}
              </Grid>
              {value.is_finance && (
                <Grid item container spacing={2} columns={18}>
                  {/* calc*/}
                  {value.is_finance && (
                    <Grid
                      item
                      container
                      spacing={2}
                      columns={18}
                      // style={{ textAlign: "center" }}
                    >
                      <Grid item md={18} sm={18} xs={18} mb={3}>
                        <FormControl>
                          {/* <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel> */}
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            // defaultValue="sunlight"
                            name="row-radio-buttons-group"
                            defaultValue={value?.financial_institution}
                          >
                            <Grid
                              item
                              container
                              spacing={3}
                              columns={18}
                              justifyContent="flex-start"
                              alignContent="center"
                            >
                              {/* {StatName === "NY" ||
                              StatName === "FL" ||
                              // StatName === "CA" ||
                              // StatName === "KY" ||
                              StatName === "CO" ||
                              StatName === "OH" ||
                              StatName === "SC" ? (
                                <></>
                              ) : (
                                <>
                                  {" "}
                                  <Grid
                                    item
                                    md={6}
                                    sm={6}
                                    xs={18}
                                    mb={1}
                                    // style={{ display: "none" }}
                                  >
                                    {" "}
                                    <FormControlLabel
                                      value="sunlight"
                                      onChange={(e) => {
                                        setValue({
                                          ...value,
                                          financial_institution: e.target.value,
                                        });
                                      }}
                                      control={<Radio />}
                                      label={
                                        <img
                                          style={{ width: "100%" }}
                                          src="data:image/png;base64,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"
                                        ></img>
                                      }
                                    />
                                  </Grid>
                                </>
                              )} */}
                              {StatName === "MI" || StatName === "IL" ? (
                                <>
                                  <Grid
                                    item
                                    md={6}
                                    sm={6}
                                    xs={18}
                                    mb={1}
                                    // style={{ display: "none" }}
                                  >
                                    <FormControlLabel
                                      value="dividend"
                                      onChange={(e) => {
                                        setValue({
                                          ...value,
                                          financial_institution: e.target.value,
                                        });
                                      }}
                                      control={<Radio />}
                                      label={
                                        <img
                                          style={{ width: "100%" }}
                                          src="data:image/jpeg;base64,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"
                                        ></img>
                                      }
                                    />
                                  </Grid>
                                </>
                              ) : (
                                <>
                                  <Grid
                                    item
                                    md={6}
                                    sm={6}
                                    xs={18}
                                    mb={1}
                                    // style={{ display: "none" }}
                                  >
                                    {" "}
                                    <FormControlLabel
                                      value="sunlight"
                                      onChange={(e) => {
                                        setValue({
                                          ...value,
                                          financial_institution: e.target.value,
                                        });
                                      }}
                                      control={<Radio />}
                                      label={
                                        <img
                                          style={{ width: "100%" }}
                                          src="data:image/png;base64,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"
                                        ></img>
                                      }
                                    />
                                  </Grid>
                                </>
                              )}

                              {StatName ? (
                                <Grid
                                  item
                                  md={6}
                                  sm={6}
                                  xs={18}
                                  mb={1}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    // display: "none",
                                  }}
                                >
                                  <FormControlLabel
                                    value="goodleap"
                                    // disabled
                                    onChange={(e) => {
                                      setValue({
                                        ...value,
                                        financial_institution: e.target.value,
                                      });
                                    }}
                                    control={<Radio />}
                                    label={
                                      <img
                                        style={{ width: "100%" }}
                                        src="data:image/svg+xml;base64,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"
                                      ></img>
                                    }
                                  />
                                </Grid>
                              ) : (
                                <span style={{ padding: "0 20px" }}></span>
                              )}

                              <Grid
                                item
                                md={6}
                                sm={6}
                                xs={18}
                                mb={1}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  // display: "none",
                                }}
                              >
                                <FormControlLabel
                                  value="mosaic"
                                  // disabled
                                  onChange={(e) => {
                                    setValue({
                                      ...value,
                                      financial_institution: e.target.value,
                                    });
                                  }}
                                  control={<Radio />}
                                  label={
                                    <img
                                      style={{ width: "70%" }}
                                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUEAAAA6CAYAAAAunOuHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAF7GlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNi4wLWMwMDYgNzkuMTY0NzUzLCAyMDIxLzAyLzE1LTExOjUyOjEzICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIiB4bWxuczpwaG90b3Nob3A9Imh0dHA6Ly9ucy5hZG9iZS5jb20vcGhvdG9zaG9wLzEuMC8iIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjQgKE1hY2ludG9zaCkiIHhtcDpDcmVhdGVEYXRlPSIyMDIxLTA1LTE0VDA4OjEyOjA3LTA0OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAyMS0wNS0xNFQwODoxNDo0OC0wNDowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAyMS0wNS0xNFQwODoxNDo0OC0wNDowMCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo4YmFhNGU1Yi01NmIzLTQ4OTctYTZmMi05MmYzNzhiMDcwNjciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MkNDRkVCN0FBQzM1MTFFQkJDMENDRDJGQUI1NThEMDEiIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoyQ0NGRUI3QUFDMzUxMUVCQkMwQ0NEMkZBQjU1OEQwMSIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJzUkdCIElFQzYxOTY2LTIuMSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjJDQ0ZFQjc3QUMzNTExRUJCQzBDQ0QyRkFCNTU4RDAxIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjJDQ0ZFQjc4QUMzNTExRUJCQzBDQ0QyRkFCNTU4RDAxIi8+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249InNhdmVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjhiYWE0ZTViLTU2YjMtNDg5Ny1hNmYyLTkyZjM3OGIwNzA2NyIgc3RFdnQ6d2hlbj0iMjAyMS0wNS0xNFQwODoxNDo0OC0wNDowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDIyLjMgKE1hY2ludG9zaCkiIHN0RXZ0OmNoYW5nZWQ9Ii8iLz4gPC9yZGY6U2VxPiA8L3htcE1NOkhpc3Rvcnk+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+SOLjYgAADt9JREFUeJztnb+P3MYVx7+KVQQuDCpAilSh5D/APChdCvEAiSBAQNoDYrfaLWgh1d2lsVLdXRWp8a1Ki8WtSsuF1gEWWKwWOLowkuYgukiCBLCO7gIEiJgAcdw4SjGPOt5wyOWPGe6edz7AQbrH3Tdz5PDxvZk3j5cgkW9P9i0AhxJV7r59fT+SqE+j0VxwXr9+LVXfZanaAAOALVmfRqPRKONHy+6ARqPRLBNtBDUazVqjjaBGo1lrtBHUaDRrjTaCGo1mrdFGUKPRrDXaCGo0mrVGdp7gWuC5Th+AmRElk+ls2GH7FoAeJw4n01moqD0bLP/zBtjfbQo+FgOIAHwFYDyZziIVfSnCcx0D7JzcAGDRT5YErH8xWB/DrvuY4rmOCeCIEx+oun5cu31OPJpMZ7Gi9mwsHjcJ2HWJAHwBdl2Stm37vv8hgJsArgO4BmAO4ATA4yAIXmY/q41gM+6CSwr3XAcdGsIj5G9yAAhlNUA3zDbYTWNU+IpJPz0Ae57rxACeABjKGNRFUD/3kL+5eQzkr1kM4BGYIUhk962EPb4vRKi4XZPa5tuMZTXQYNwYYOfCBrBDOkYAnjR5KPi+fxPAJwCuAPgMwH0Ar8CM4U0AX/u+/zAIgvvpdy7VbaSMb0/2bQDHElVuvn19P5SoTwqe6xwjP4gTABuqnqqZtveRH8gA8yT2Jeg3wLY+9tvqIhIAj2T0jafkXNQlATOGSg028Ob8vio4vKHSOyXPjL8/N2V4oPR37YEMmSRCALv8OSnaNkcG8DmYx/cB7/HRZz4C8ADMI7wH6DlBmRjIhzhSoTBYxk1fpL8H4BTyDCDAzsue5zovqP9S8FznCPLOhUG6XpChUMlOybFtxW0rgc7ZKeQaQIA5Gi/oYVeK7/tXADwF8BLArSAIXvq+/7Xv+6/p52vf998PguAhgIcAPiSjqY2gZGzPdXYU6ldmZGmgPUNxCJMAGAM4ALDJ/QwADMHmdYqwwAZ0X0Jfj1BsqMOCPu5SH+MS1SaAY1XXkLylMkPXp3DywkDX8xjloe8Y7Jps4fw12SJ5uKCZPc91jun8FfE+WAj8MAiC1NO+BhYO/4R+/4T+fUj/fgjoOUEV7HmuM5YdFpORsmTqzOguMyoxWKg9qqjLRPmc0BHNn1bSJ9Dfg7ivY7DQKS74akj/7pJHug02fynqoyqqtLcNZrBXnirjBmyRLClRMyZdBpgneRfiBRQb7AG1BfGD7CYABEHwuKStE/rMq08//XQ+n8+vA9oTVIEByR6byjC4ZCAnAAaT6exqHYM1mc7iyXS2C2ADNMAFHLXwCEWl2kaT6Wyr6oNnMp1Fk+lsAOAqgBF3eKxwgUu0KDHmZP0FHs9KQN5yv+DwQTpuqs6xTqazhOaNN8CMpwgLxY7AlQL5AwD/pP/f445dA7QRVIXssFhJGEyGqC84FIFN0o+a6iZjuAUWKos4rDtHSF6gyYnHZNBqQzfeACw0S8A8jEa6FiFIqwLYYswjTmZA7pysdGgOUPQwSsDGzX5T3ZwxjLjDg8l0Ni746gkA+L5/jZPfB/AumMH7KCO/ln5HG0F17MmY31EVBlPfRAM5AlsxjGW0Q4ZUZFgM1DfulkBW5DVUhlZHrwLYUrg6fJf7PZ5MZ2NqO+KOrewCCXmpzwSHErBxE8loh/Rs4sxTHi14KJ/Qv+/zB2iVeJ4e833/5nw+T3MHtRGURIj85K6Blh5cSRjc+sYH65vBySKwgZxI0P+GEkNoVVn5y3CD+z2ReNNJ08WTSRrOkr2GvDdoylhAUsQh8uMmgUQDmELXZAvMAyz10IMg+AzMqD3wff86iec4S0eaAzghT/EByR4DwOV//O5OH/mnVCP+++VfjHd+9WsZqgAAt//27eEvj58nktTtfrl5K5KkS8QAwAucHyC25zo7LeaYREY0XU1rPEdYcFMCbLAlTfWWMZnORp7rvId8GsW25zpN8/Oitv3qCP7+SpCZC6Rzs4fz4fI28vOVS6VgxwkgyOWTSY1pmftgeYLPfd+/FwTBrfRAEAQPfd9/DJZGcx3AvTSP8DLYibdldPZ///kOl3/GP6yb8++/zi1pyhSvAk6ms9hznQPkQ8xGq8UFYXA0mc72JeSyFSVbRy31LuIAbIXUzMgMMMO430Cf1a476ikwHI8ERv8Jzl8Xy3MdW/VWupqIxk3YZu5YJkEQnPi+fwssFeap7/snOPMGr+EsjeZedhVZh8MSIY9vzIkN1AyLS8Lg1pP2dFPanDgBy6FTCt34olC+aiSScL8bFyCvTnQdRwLZEPm/T1lifF1oLrAvOKRkIakpQRCcBEHwC7CV4Jdghu8BmPf3GMC7fBqNzhOUzwDMyBgZWd2wWBgGS/LURJPuIs9ECQWhn1nR6/kK+cIRh2BJtytHpqhDFmHBgsl0lniuM8Z5Q2N7rmOq3opZkZ5AFq5I33KQoSvLGXyD9gQlQ8ZE9HSstFpcFga37FqKLZCNJOmuylggu9Pwez3KdVxFdpCfhuEXQbKIvORV8QZF1+dJ571QgDaCCqBcpjEnNrAgLFYZBpN+A2IDG8vQXwPRzWMt+hJ5wqHgUJ/2JtuteiUf3usuLd9F12HEiVdlK50tkI077oMStBFUxwD5OR57QUqIyjAYUFx+qyoFf49d8etFW8ossG1Vp57r7CzbcFCKi8GJy7zAFNEDot+yO62gh6fBiaOOy48pQxtBRSwIiy1eWBAGh5JLUJkC2TcS9dch5AVVtouRAS3zjE2wecJTMoiHnuv0lmAUeY8+Ltnt8AaaFw058faSt9JZAlnUcR+UoY2gQmjQDwWHznl8BWFwAvkrb6ZAFkluow1WlQ9RSka61a0ME2xe7hnOjOKR5zpK9+cWbO+rk+DOe4MGxAsTy2RZD0/paCOongPkq17wOyWKwmD+ez8kvmjz5cxWtwMsNoYpJlhoeQTglec6zxTNI/JzgUnNIhQj5MfMqiyQ/ODQRlAxi8LikjB4qLZnF5/MZvurYHOFUU0VPbB5xGNZxpC8el5XlblAnou0le5Co41gB5DXMhQcElVHTrBiCaiKeE+WIjKGw8l0toEzgzhGdQ/RBjOG+xK6I8rDHDbQM0K+/1K2t2rOo41gdwjDYtHnFIbBiUAm6kMXGAJZ3FYplfAaUn3BK2BGcQBmVBbp32uTc1jyNrekri76zogT2yuUBvTzZXdAFtoIdgQN6kU7G1SHwZFAtqzBbPECFcafjOJoMp0NJtPZVbA6dUMUe4n9FrUgRV5gm4o/ojB6GWW2YoHM6rgPytBGsEMovaPopkigfvtXLJDZitvMQR6TwYnDLtqmqtK7OFtUEbFXd/W4YG9tq21lBcnTnaf7FPwN1kWogF0FvXe4Y6gKzB3kn6TKylhl2o7pXbtmRmwtYX9qTyCLOmw/9cz3ab8u/6IgA8ygDWuo3EHesNue64jfD9mOPXQ/bxwi/8DsYcXKfTVBe4LLgR/A4yqJtJIIBbJ+R22niCb4W6XMNIW8c9EulCp7mbN0uWixjPeQfC6Q1T1HK4k2gkuAC4sTdPtUFw3mznYk0MS+xYmTDh8COSgvL+HEVtXvF7w/RDU7Hbc3FsiWsRNHOtoILgnKb4vQQRjMtTtGfm7QQHc3lSjpt0kenWwi7nejxneXkcjc6QIJTZeEgkOrWsGnMpfBbohQhrK/X3rHmP/xz5YMXQDw1nffR9//+K1EkjpZeqRBeW3L4AD5wZtWwI5UNUqrrrbg0EhVm6ohz9bkxEOIPe423MH5B5XhuU6/46rOB8hfP9tznd4yPfm2XP7pbz8fQdIgvP3xUxt/+NOxDF0AYAC7v//NB6EsfRpGQWFTgL0PWPqLloDyl0bVWZQhQ9oo964mVfULPVvZC020oLUjaHsks50yJtNZ6LlOiLwhPPJcJ1b4oqo+WNUaJfp1OLy+CN/+BrZzwpDZEBlAfgUWYFHIsIaeHbAKMccy56Lo77U5cVThe5bge8LK0W0pSJcxqVhDl4gWkQwwQ2jIboyS14/ArrklWz+gjeDaUrKVz4JEQ1hiAIEa86HkDaQvsbIAvJBoAETeXJVwVviqgpZ9KWPpydMlua4W2DWxZLTjuY7huc4znGUuGFBkCLURXGMoaTgSHLLASk/12uinvbj8a0hTBlXfpFbwongDwDOqBGO26GMf4kWhUYU+9TlxaeXothRU1u58Kx0t6o0Eh0wwQ7XTRj+Nu1Pk80kNKFiE0kZQswmxITTAjMxxXWNI9fpOUTxghzVLS8UoLuXeAzPYR3W8hIynUVTGLFmgoi+QdbHKLao8vYzCCkUPUAPAIb3uoF9HIRW/PQar/2gIPjKGgnSySzKV3f74qQ0W+shicxUXRuhC2RlROJnONjts30b+PB80rUJNoe8xynPjYjAv5Av6f0RvSDPBPAALrDJMD+XpJYOmK5qZkLhMfwx2s3xF/4/TObrMSu4NFCeIR4tW7el8nXL9iGlvsnLoAWNy4quL5iILxs1m03cb03k4RHmyfQJ2PYrGjQl2PWyU51qOJtPZAABev5a7CUdvm9OkW8g2PNc5RHG+oAk22PupwHOdOs0kALbavEycVrVDMO/NLviYCe5vqNHPCMwzXkQfeUPcplBCXR4hPz3Q+Va6tFam5zrfoNjrN9B+3OyqTAXS4bDmDTRHuAkJJa04RmCeSthWEVWF2QQrNhG31ZdhDOYVJRU+26pytARGyKfw9JZV0IAikA3IL4IxBrCh+txqI6g5x2Q6CymsG6B9UYMRmPGTvitmMp2NqZ9baPfqxxDM+G1V6WPBFrlOd7wU1Bo00P1WujdQdZ5NsHETtlQ3xtk1iVvqWogOh5vxBOc3/Mcdtx8jH36FMhugp+8okwuXVr4xFvQrBDs34y62A6bveM7k+t0A66cJ8RxTDGbc0z7GDZrlz/2wgY62PALwL04WL/hOjHzfF32nFplxY4LND1cdNxHaXZPG6IURTS0KXuCeqEwN0Vx8ZI4bvTCiWSrk3YVL7obmgrHK40bPCWo0mrVGG0GNRrPWaCOo0WjWGm0ENRrNWqONoEajWWu0EdRoNGuN7BSZBHKXwROJujQajSbH/wFTIABP1aBT8wAAAABJRU5ErkJggg=="
                                    ></img>
                                  }
                                />
                              </Grid>
                              <Grid
                                item
                                md={6}
                                sm={6}
                                xs={18}
                                mb={1}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  display: "none",
                                }}
                              >
                                <FormControlLabel
                                  value="concert"
                                  // disabled
                                  onChange={(e) => {
                                    setValue({
                                      ...value,
                                      financial_institution: e.target.value,
                                    });
                                    dispatch(
                                      createConcertApplication({
                                        lead_id: singlead?.id,
                                      })
                                    );
                                  }}
                                  control={<Radio />}
                                  label={
                                    <img
                                      style={{ width: "80%" }}
                                      src="data:image/jpeg;base64,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"
                                    ></img>
                                  }
                                />
                              </Grid>
                            </Grid>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      {/* SunLight Screen */}
                      {value.financial_institution === "sunlight" && (
                        <>
                          <Grid item xs={18}>
                            <ClacButton>
                              <Calc />
                              {/* <Calc
                                servicId={value.service_type_id}
                                totalAmount={totalAmount}
                              ></Calc> */}
                            </ClacButton>
                          </Grid>
                          {/* loan_years*/}
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            {/* <InputLabel> Loan Month</InputLabel>
                          <FormControl fullWidth>
                            <TextField
                              required
                              disabled={true}
                              value={info?.term || " Loan Month"}
                            />
                          </FormControl> */}
                            <CalcSunLightData>
                              <span>{info?.term || 0}</span>
                              <h5>Loan Term</h5>
                            </CalcSunLightData>
                          </Grid>
                          {/* finalMonthlyPayment*/}
                          {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                          <InputLabel> Final Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            required
                            disabled={true}
                            value={calculator.finalMonthlyPayment}

                          />
                        </Grid> */}
                          {/* finalEscalatedMonthlyPayment*/}
                          {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                          <InputLabel> Final Escalated Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            required
                            disabled={true}
                            value={calculator.finalEscalatedMonthlyPayment}

                          />
                        </Grid> */}
                          {/* monthlyPayment*/}
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            {/* <InputLabel> Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            disabled={true}
                            required
                            value={calculator.monthlyPayment}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                monthlyPayment: calculator.monthlyPayment,
                              })
                            }
                          /> */}
                            <CalcSunLightData>
                              <span>${Math.ceil(MONTH_PAY) || 0}</span>
                              <h5>Monthly payment for 1-17</h5>
                            </CalcSunLightData>
                          </Grid>
                          {/* escalatedMonthlyPayment*/}
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            {/* <InputLabel> Escalated Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            disabled={true}
                            required
                            value={calculator.escalatedMonthlyPayment}
                            onChange={MonthChage}

                          /> */}
                            <CalcSunLightData>
                              <span>
                                $
                                {Math.floor(
                                  calculator.escalatedMonthlyPayment
                                ) || 0}
                              </span>
                              <h5>Monthly payment for 18+</h5>
                              <p style={{ fontSize: "10px" }}>
                                Assuming tax credit is NOT applied to Solar
                              </p>
                            </CalcSunLightData>
                          </Grid>
                        </>
                        //     <>
                        //       <Grid item xs={18}>
                        //         <ClacButton>
                        //           <Calc
                        //             servicId={value.service_type_id}
                        //             totalAmount={totalAmount}
                        //           ></Calc>
                        //         </ClacButton>
                        //       </Grid>
                        //       {/* loan_years*/}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>{TheOffer?.term || 0}</span>
                        //           <p style={{ fontSize: "14px" }}>Loan Term</p>
                        //           <p style={{ fontSize: "10px" }}>Term in Years</p>
                        //         </CalcSunLightData>
                        //       </Grid>
                        //       {/* monthlyPayment*/}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>
                        //             $
                        //             {
                        //               // Math.ceil(
                        //               resultFromPaymentCalc[0]?.roundedAmount
                        //                 ?.value || 0
                        //               // ) || 0
                        //             }
                        //           </span>
                        //           <p style={{ fontSize: "10px" }}>
                        //             {/* Estimated initial monthly payment for 18 months */}
                        //             {resultFromPaymentCalc[0]?.paymentDescription}
                        //           </p>
                        //           {/* <p style={{fontSize:"10px"}}>Estimated initial monthly payment for 18 months</p> */}
                        //         </CalcSunLightData>
                        //       </Grid>
                        //       {/* escalatedMonthlyPayment*/}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>
                        //             $
                        //             {
                        //               // Math.floor(
                        //               resultFromPaymentCalc[1]?.roundedAmount
                        //                 ?.value || 0
                        //               // ) || 0
                        //             }
                        //           </span>
                        //           <p style={{ fontSize: "10px" }}>
                        //             {/* Estimated adjusted monthly payment after 18
                        //     months without paydown */}
                        //             {resultFromPaymentCalc[1]?.paymentDescription}
                        //           </p>
                        //           {/* <p style={{ fontSize: "10px" }}>
                        //  Assuming tax credit is NOT applied to Solar
                        //  Estimated adjusted monthly payment after 18 months without paydown
                        //   </p> */}
                        //         </CalcSunLightData>
                        //       </Grid>
                        //       {/* New In Good Leap */}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>
                        //             $
                        //             {
                        //               // Math.floor(
                        //               resultFromPaymentCalc[2]?.roundedAmount
                        //                 ?.value || 0
                        //               // ) || 0
                        //             }
                        //           </span>
                        //           <p style={{ fontSize: "10px" }}>
                        //             {" "}
                        //             {/* Estimated adjusted monthly payment after 18
                        //     months with paydown */}
                        //             {resultFromPaymentCalc[2]?.paymentDescription}
                        //           </p>
                        //           {/* <p style={{ fontSize: "10px" }}>
                        //  Assuming tax credit is NOT applied to Solar
                        //  Estimated adjusted monthly payment after 18 months with paydown
                        //   </p> */}
                        //         </CalcSunLightData>
                        //       </Grid>
                        //     </>
                      )}
                      {/* SunLight Screen */}
                      {value.financial_institution === "dividend" && (
                        <>
                          <Grid item xs={18}>
                            <ClacButton>
                              <FakeCalc />
                              {/* <Calc
                                servicId={value.service_type_id}
                                totalAmount={totalAmount}
                              ></Calc> */}
                            </ClacButton>
                          </Grid>
                          {/* loan_years*/}
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            {/* <InputLabel> Loan Month</InputLabel>
                          <FormControl fullWidth>
                            <TextField
                              required
                              disabled={true}
                              value={info?.term || " Loan Month"}
                            />
                          </FormControl> */}
                            <CalcSunLightData>
                              <span>{info?.term || 0}</span>
                              <h5>Loan Term</h5>
                            </CalcSunLightData>
                          </Grid>
                          {/* finalMonthlyPayment*/}
                          {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                          <InputLabel> Final Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            required
                            disabled={true}
                            value={calculator.finalMonthlyPayment}

                          />
                        </Grid> */}
                          {/* finalEscalatedMonthlyPayment*/}
                          {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                          <InputLabel> Final Escalated Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            required
                            disabled={true}
                            value={calculator.finalEscalatedMonthlyPayment}

                          />
                        </Grid> */}
                          {/* monthlyPayment*/}
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            {/* <InputLabel> Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            disabled={true}
                            required
                            value={calculator.monthlyPayment}
                            onChange={(e) =>
                              setValue({
                                ...value,
                                monthlyPayment: calculator.monthlyPayment,
                              })
                            }
                          /> */}
                            <CalcSunLightData>
                              <span>${Math.ceil(MONTH_PAY) || 0}</span>
                              <h5>Monthly payment for 1-17</h5>
                            </CalcSunLightData>
                          </Grid>
                          {/* escalatedMonthlyPayment*/}
                          <Grid item md={6} sm={9} xs={18} mb={3}>
                            {/* <InputLabel> Escalated Monthly Payment </InputLabel>
                          <TextField
                            fullWidth
                            disabled={true}
                            required
                            value={calculator.escalatedMonthlyPayment}
                            onChange={MonthChage}

                          /> */}
                            <CalcSunLightData>
                              <span>
                                $
                                {Math.floor(
                                  calculator.escalatedMonthlyPayment
                                ) || 0}
                              </span>
                              <h5>Monthly payment for 18+</h5>
                              <p style={{ fontSize: "10px" }}>
                                Assuming tax credit is NOT applied to Solar
                              </p>
                            </CalcSunLightData>
                          </Grid>
                        </>
                        //     <>
                        //       <Grid item xs={18}>
                        //         <ClacButton>
                        //           <Calc
                        //             servicId={value.service_type_id}
                        //             totalAmount={totalAmount}
                        //           ></Calc>
                        //         </ClacButton>
                        //       </Grid>
                        //       {/* loan_years*/}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>{TheOffer?.term || 0}</span>
                        //           <p style={{ fontSize: "14px" }}>Loan Term</p>
                        //           <p style={{ fontSize: "10px" }}>Term in Years</p>
                        //         </CalcSunLightData>
                        //       </Grid>
                        //       {/* monthlyPayment*/}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>
                        //             $
                        //             {
                        //               // Math.ceil(
                        //               resultFromPaymentCalc[0]?.roundedAmount
                        //                 ?.value || 0
                        //               // ) || 0
                        //             }
                        //           </span>
                        //           <p style={{ fontSize: "10px" }}>
                        //             {/* Estimated initial monthly payment for 18 months */}
                        //             {resultFromPaymentCalc[0]?.paymentDescription}
                        //           </p>
                        //           {/* <p style={{fontSize:"10px"}}>Estimated initial monthly payment for 18 months</p> */}
                        //         </CalcSunLightData>
                        //       </Grid>
                        //       {/* escalatedMonthlyPayment*/}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>
                        //             $
                        //             {
                        //               // Math.floor(
                        //               resultFromPaymentCalc[1]?.roundedAmount
                        //                 ?.value || 0
                        //               // ) || 0
                        //             }
                        //           </span>
                        //           <p style={{ fontSize: "10px" }}>
                        //             {/* Estimated adjusted monthly payment after 18
                        //     months without paydown */}
                        //             {resultFromPaymentCalc[1]?.paymentDescription}
                        //           </p>
                        //           {/* <p style={{ fontSize: "10px" }}>
                        //  Assuming tax credit is NOT applied to Solar
                        //  Estimated adjusted monthly payment after 18 months without paydown
                        //   </p> */}
                        //         </CalcSunLightData>
                        //       </Grid>
                        //       {/* New In Good Leap */}
                        //       <Grid item md={4.5} sm={9} xs={18} mb={3}>
                        //         <CalcSunLightData>
                        //           <span>
                        //             $
                        //             {
                        //               // Math.floor(
                        //               resultFromPaymentCalc[2]?.roundedAmount
                        //                 ?.value || 0
                        //               // ) || 0
                        //             }
                        //           </span>
                        //           <p style={{ fontSize: "10px" }}>
                        //             {" "}
                        //             {/* Estimated adjusted monthly payment after 18
                        //     months with paydown */}
                        //             {resultFromPaymentCalc[2]?.paymentDescription}
                        //           </p>
                        //           {/* <p style={{ fontSize: "10px" }}>
                        //  Assuming tax credit is NOT applied to Solar
                        //  Estimated adjusted monthly payment after 18 months with paydown
                        //   </p> */}
                        //         </CalcSunLightData>
                        //       </Grid>
                        //     </>
                      )}
                      {/* Good Leap Screen */}
                      {value.financial_institution === "goodleap" && (
                        <>
                          <Grid item xs={18}>
                            <ClacButton>
                              <CalcGoodLeadp
                                servicId={value.service_type_id}
                                totalAmount={totalAmount}
                              />
                            </ClacButton>
                          </Grid>
                          {/* loan_years*/}
                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              <span>{TheOffer?.term || 0}</span>
                              <p style={{ fontSize: "14px" }}>Loan Term</p>
                              <p style={{ fontSize: "10px" }}>Term in Years</p>
                            </CalcSunLightData>
                          </Grid>
                          {/* monthlyPayment*/}
                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              <span>
                                $
                                {
                                  // Math.ceil(
                                  resultFromPaymentCalc[0]?.roundedAmount
                                    ?.value || 0
                                  // ) || 0
                                }
                              </span>
                              <p style={{ fontSize: "10px" }}>
                                {/* Estimated initial monthly payment for 18 months */}
                                {resultFromPaymentCalc[0]?.paymentDescription}
                              </p>
                              {/* <p style={{fontSize:"10px"}}>Estimated initial monthly payment for 18 months</p> */}
                            </CalcSunLightData>
                          </Grid>
                          {/* escalatedMonthlyPayment*/}
                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              <span>
                                $
                                {
                                  // Math.floor(
                                  resultFromPaymentCalc[1]?.roundedAmount
                                    ?.value || 0
                                  // ) || 0
                                }
                              </span>
                              <p style={{ fontSize: "10px" }}>
                                {/* Estimated adjusted monthly payment after 18
                                months without paydown */}
                                {resultFromPaymentCalc[1]?.paymentDescription}
                              </p>
                              {/* <p style={{ fontSize: "10px" }}>
                             Assuming tax credit is NOT applied to Solar
                             Estimated adjusted monthly payment after 18 months without paydown
                              </p> */}
                            </CalcSunLightData>
                          </Grid>
                          {/* New In Good Leap */}
                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              <span>
                                $
                                {
                                  // Math.floor(
                                  resultFromPaymentCalc[2]?.roundedAmount
                                    ?.value || 0
                                  // ) || 0
                                }
                              </span>
                              <p style={{ fontSize: "10px" }}>
                                {" "}
                                {/* Estimated adjusted monthly payment after 18
                                months with paydown */}
                                {resultFromPaymentCalc[2]?.paymentDescription}
                              </p>
                              {/* <p style={{ fontSize: "10px" }}>
                             Assuming tax credit is NOT applied to Solar
                             Estimated adjusted monthly payment after 18 months with paydown
                              </p> */}
                            </CalcSunLightData>
                          </Grid>
                        </>
                      )}
                      {/* Mosaic */}
                      {value.financial_institution === "mosaic" ? (
                        <>
                          {/* <Grid container item columns={18} spacing={2}> */}
                          <Grid item xs={18}>
                            <ClacButton>
                              <Mosiac
                                servicId={value.service_type_id}
                                totalAmount={totalAmount}
                              ></Mosiac>
                            </ClacButton>
                          </Grid>
                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              <span>{payments?.totalPeriods / 12 || 0}</span>
                              <p style={{ fontSize: "14px" }}>Loan Term</p>
                              <p style={{ fontSize: "10px" }}>Term in Years</p>
                            </CalcSunLightData>
                          </Grid>
                          {/* monthlyPayment*/}

                          {payments?.prePaymentAmount > 0 ? (
                            <>
                              <Grid item md={4.5} sm={9} xs={18} mb={3}>
                                <CalcSunLightData>
                                  <span>
                                    $
                                    {CommaFormatted(
                                      Math.ceil(payments?.prePaymentAmount)
                                    )}
                                  </span>
                                  <p style={{ fontSize: "14px" }}>
                                    Extra payment
                                  </p>
                                  <p style={{ fontSize: "14px" }}>
                                    Before month 18
                                  </p>
                                </CalcSunLightData>
                              </Grid>
                              {mosaicPaymentWithPrePayment?.map((e, i) => {
                                return (
                                  <Grid
                                    item
                                    md={4.5}
                                    sm={9}
                                    xs={18}
                                    mb={3}
                                    key={i}
                                  >
                                    <CalcSunLightData>
                                      <span>
                                        {allMosiacData?.mosaic_is_ach ===
                                        true ? (
                                          <>
                                            $
                                            {CommaFormatted(
                                              Math.ceil(e?.monthlyPayment) || 0
                                            ) || 0}
                                          </>
                                        ) : (
                                          <>
                                            $
                                            {CommaFormatted(
                                              Math.ceil(
                                                e?.monthlyPaymentWithoutAchDiscount
                                              ) || 0
                                            ) || 0}
                                          </>
                                        )}
                                      </span>
                                      <p style={{ fontSize: "14px" }}>
                                        {/* Estimated initial monthly payment for 18 months */}
                                        {i === 0 ? (
                                          <>Before month 18</>
                                        ) : (
                                          <>After month 18</>
                                        )}
                                        {/* {i=== payments?.monthlyPayments[payments?.monthlyPayments.length-1]? <>Last </>:<></>} */}

                                        {/* {payments?.monthlyPayments[payments?.monthlyPayments.length-1] ? <>Last </>:<></>}  */}
                                        {/* {payments?.monthlyPayments[0] ? <>First</>:<></>} */}
                                        {/* {payments?.monthlyPayments[0] ? <>First</>:<></>}      */}
                                      </p>
                                      {/* <p style={{fontSize:"10px"}}>Estimated initial monthly payment for 18 months</p> */}
                                    </CalcSunLightData>
                                  </Grid>
                                );
                              })}
                            </>
                          ) : (
                            <>
                              {payments?.monthlyPayments
                                ?.slice(1, -1)
                                ?.map((e, i) => {
                                  return (
                                    <Grid
                                      item
                                      md={4.5}
                                      sm={9}
                                      xs={18}
                                      mb={3}
                                      key={i}
                                    >
                                      <CalcSunLightData>
                                        <span>
                                          {allMosiacData?.mosaic_is_ach ===
                                          true ? (
                                            <>
                                              $
                                              {Math.ceil(
                                                e?.monthlyPayment || 0
                                              ) || 0}
                                            </>
                                          ) : (
                                            <>
                                              $
                                              {CommaFormatted(
                                                Math.ceil(
                                                  e?.monthlyPaymentWithoutAchDiscount
                                                ) || 0
                                              ) || 0}
                                            </>
                                          )}
                                        </span>
                                        <p style={{ fontSize: "14px" }}>
                                          {/* Estimated initial monthly payment for 18 months */}
                                          {i === 0 ? (
                                            <>Before month 18</>
                                          ) : (
                                            <>After month 18</>
                                          )}
                                          {/* {i=== payments?.monthlyPayments[payments?.monthlyPayments.length-1]? <>Last </>:<></>} */}

                                          {/* {payments?.monthlyPayments[payments?.monthlyPayments.length-1] ? <>Last </>:<></>}  */}
                                          {/* {payments?.monthlyPayments[0] ? <>First</>:<></>} */}
                                          {/* {payments?.monthlyPayments[0] ? <>First</>:<></>}      */}
                                        </p>
                                        {/* <p style={{fontSize:"10px"}}>Estimated initial monthly payment for 18 months</p> */}
                                      </CalcSunLightData>
                                    </Grid>
                                  );
                                })}
                            </>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                      {/* Concert */}
                      {value.financial_institution === "concert" ? (
                        <>
                          {/* <Grid container item columns={18} spacing={2}> */}
                          <Grid item xs={18}>
                            <ClacButton>
                              <Concert
                                servicId={value.service_type_id}
                                totalAmount={totalAmount}
                              ></Concert>
                            </ClacButton>
                          </Grid>
                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              <span>{concertPayments?.term || 0}</span>
                              <p style={{ fontSize: "14px" }}>Loan Term</p>
                              <p style={{ fontSize: "10px" }}>Term in Years</p>
                            </CalcSunLightData>
                          </Grid>
                          {/* monthlyPayment*/}
                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              {concertPayments?.loanType === "Choice" ? (
                                <>
                                  <span>$ 0</span>
                                  <p style={{ fontSize: "10px" }}>
                                    First{" "}
                                    {concertPayments?.calculations?.introTerm}{" "}
                                    month
                                  </p>
                                </>
                              ) : (
                                <>
                                  <span>$ 0</span>
                                  <p style={{ fontSize: "10px" }}>
                                    First 12 months
                                  </p>
                                </>
                              )}

                              {/* <p style={{fontSize:"10px"}}>Estimated initial monthly payment for 18 months</p> */}
                            </CalcSunLightData>
                          </Grid>
                          {/* escalatedMonthlyPayment*/}
                          {concertPayments?.loanType === "Choice" ? (
                            <>
                              <Grid item md={4.5} sm={9} xs={18} mb={3}>
                                <CalcSunLightData>
                                  <span>
                                    $
                                    {Math.ceil(
                                      concertPayments?.calculations
                                        ?.averageMonthlyFinancingPaymentWithoutPrepaymentPreReAm
                                    ) || 0}
                                  </span>
                                  <p style={{ fontSize: "10px" }}>
                                    Months 3-
                                    {
                                      concertPayments?.calculations
                                        ?.reAmortizationMonth
                                    }
                                  </p>
                                </CalcSunLightData>
                              </Grid>
                            </>
                          ) : (
                            <></>
                          )}

                          <Grid item md={4.5} sm={9} xs={18} mb={3}>
                            <CalcSunLightData>
                              <span>
                                $
                                {Math.round(
                                  concertPayments?.calculations
                                    ?.averageMonthlyFinancingPaymentWithoutPrepayment ||
                                    0
                                ) || 0}
                              </span>
                              <p style={{ fontSize: "10px" }}>
                                {" "}
                                <p> (Without Prepayment )</p>
                                {concertPayments?.loanType === "Choice" ? (
                                  <>
                                    Months 19 -{concertPayments?.term * 12 || 0}
                                  </>
                                ) : (
                                  <>
                                    Months 13-
                                    {concertPayments?.term * 12 +
                                      concertPayments?.calculations
                                        ?.deferralMonth}
                                  </>
                                )}
                              </p>
                              {/* <p style={{ fontSize: "10px" }}>
                             Assuming tax credit is NOT applied to Solar
                             Estimated adjusted monthly payment after 18 months with paydown
                              </p> */}
                            </CalcSunLightData>
                          </Grid>
                          {concertPayments?.prePaymentPercent > 0 ? (
                            <>
                              <Grid item md={4.5} sm={9} xs={18} mb={3}>
                                <CalcSunLightData>
                                  <span>
                                    $
                                    {concertPayments?.loanType === "Zero" ? (
                                      <>
                                        {Math.round(
                                          concertPayments?.calculations
                                            ?.averageMonthlyFinancingPaymentWithPrepayment ||
                                            0
                                        ) || 0}
                                      </>
                                    ) : (
                                      <>
                                        {" "}
                                        {Math.round(
                                          concertPayments?.calculations
                                            ?.averageMonthlyFinancingPaymentWithPrepaymentPreReAm ||
                                            0
                                        ) || 0}
                                      </>
                                    )}
                                  </span>
                                  <p style={{ fontSize: "10px" }}>
                                    {" "}
                                    {concertPayments?.loanType === "Choice" ? (
                                      <>
                                        (With Prepayment )
                                        <p>
                                          {" "}
                                          Months 19 -
                                          {concertPayments?.term * 12 || 0}{" "}
                                        </p>
                                      </>
                                    ) : (
                                      <>
                                        <p>(Without Prepayment )</p>
                                        Months 13-
                                        {concertPayments?.term * 12 +
                                          concertPayments?.calculations
                                            ?.deferralMonth}
                                      </>
                                    )}
                                  </p>
                                  {/* <p style={{ fontSize: "10px" }}>
                             Assuming tax credit is NOT applied to Solar
                             Estimated adjusted monthly payment after 18 months with paydown
                              </p> */}
                                </CalcSunLightData>
                              </Grid>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </Grid>
                  )}

                  {/* loan_years*/}
                  {/* <Grid item md={6} sm={9} xs={18} mb={3}> */}
                  {/* <InputLabel> Loan Month</InputLabel>
                    <FormControl fullWidth>
                      <TextField
                        required
                        disabled={true}
                        value={info?.term || " Loan Month"}
                      />
                    </FormControl> */}
                  {/* <CalcSunLightData>
                      <span>{info?.term || 0}</span>
                      <h5>Loan Term</h5>
                    </CalcSunLightData>
                  </Grid> */}
                  {/* finalMonthlyPayment*/}
                  {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel> Final Monthly Payment </InputLabel>
                    <TextField
                      fullWidth
                      required
                      disabled={true}
                      value={calculator.finalMonthlyPayment}
        
                    />
                  </Grid> */}
                  {/* finalEscalatedMonthlyPayment*/}
                  {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel> Final Escalated Monthly Payment </InputLabel>
                    <TextField
                      fullWidth
                      required
                      disabled={true}
                      value={calculator.finalEscalatedMonthlyPayment}
         
                    />
                  </Grid> */}
                  {/* monthlyPayment*/}
                  {/* <Grid item md={6} sm={9} xs={18} mb={3}> */}
                  {/* <InputLabel> Monthly Payment </InputLabel>
                    <TextField
                      fullWidth
                      disabled={true}
                      required
                      value={calculator.monthlyPayment}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          monthlyPayment: calculator.monthlyPayment,
                        })
                      }
                    /> */}
                  {/* <CalcSunLightData>
                      <span>${Math.ceil(MONTH_PAY) || 0}</span>
                      <h5>Monthly payment for 1-17</h5>
                    </CalcSunLightData>
                  </Grid> */}
                  {/* escalatedMonthlyPayment*/}
                  {/* <Grid item md={6} sm={9} xs={18} mb={3}> */}
                  {/* <InputLabel> Escalated Monthly Payment </InputLabel>
                    <TextField
                      fullWidth
                      disabled={true}
                      required
                      value={calculator.escalatedMonthlyPayment}
                      onChange={MonthChage}
                      
                    /> */}
                  {/* <CalcSunLightData>
                      <span>
                        ${Math.floor(calculator.escalatedMonthlyPayment) || 0}
                      </span>
                      <h5>Monthly payment for 18+</h5>
                      <p style={{ fontSize: "10px" }}>
                        Assuming tax credit is NOT applied to Solar
                      </p>
                    </CalcSunLightData>
                  </Grid> */}
                  {/* paydownPercentage*/}
                  {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel> Paydown Percentage</InputLabel>
                    <TextField
                      fullWidth
                      disabled={true}
                      required
                      value={calculator.paydownPercentage}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          paydownPercentage: calculator.paydownPercentage,
                        })
                      }
                    />
                  </Grid> */}
                  {/* alternateMonthlyPayment*/}
                  {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                    <InputLabel> Alternate Monthly Payment</InputLabel>
                    <TextField
                      fullWidth
                      disabled={true}
                      required
                      type="number"
                      value={calculator.alternateMonthlyPayment}
                      onChange={(e) =>
                        setValue({
                          ...value,
                          alternateMonthlyPayment: Number(e.target.value),
                        })
                      }
                    />
                  </Grid> */}
                </Grid>
              )}

              {/* {calculator && <Grid item container spacing={2} columns={18}></Grid>} */}

              {/*************************** */}
              <ButtonContainer>
                <Button type="submit" variant="contained">
                  Add Solution
                </Button>
              </ButtonContainer>
            </form>
          </FormConatiner>

          {isLoading && <LoadingSoultion />}
          {isSuccess && (
            <Modal
              open={open}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <ModelConatiner>
                  <div className="icon">
                    <CheckCircle />
                  </div>
                  <p>Solution has been created successfully</p>
                  <div className="btn_sucess">
                    <Button
                      variant="contained"
                      className="go_lead"
                      onClick={handleGoToLeads}
                    >
                      Go to Lead Profile
                    </Button>
                    {/* <Button
                      variant="contained"
                      className="add_lead"
                      onClick={handleAddLead}
                    >
                      Add New Solution
                    </Button> */}
                  </div>
                </ModelConatiner>
              </Box>
            </Modal>
          )}
        </>
      )}

      {isSingleLeadLoading && isCalc && isUtility && isPanle && (
        <LoadingContainer>
          <Loading />
        </LoadingContainer>
      )}
      {/* Hvacs */}
      <Modal
        open={openHvac}
        onClose={handleCloseHvac}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleHvac}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            align="center"
          >
            HVAC Form
            <hr></hr>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <form onSubmit={AddHvac}>
              <Grid container columns={18} spacing={2}>
                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
              <span>No</span>
              <Switch
                checked={value.is_hvac}
                onChange={(e) =>
                  setValue({
                    ...value,
                    is_hvac: e.target.checked,
                  })
                }
                inputProps={{ "aria-label": "controlled" }}
              />
              <span>Yes</span>
            </Grid> */}
                {/* {value.is_hvac && ( */}
                <>
                  {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                      <TextField
                        fullWidth
                        label="Number of HVACS"
                        value={value.number_of_hvacs}
                        onChange={(e) =>
                          setValue({
                            ...value,
                            number_of_hvacs: Number(e.target.value),
                          })
                        }
                      />
                    </Grid> */}
                  {/* Existing Electrical Panel*/}

                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        HVAC Location
                      </InputLabel>
                      <Select
                        required={true}
                        id="demo-simple-select"
                        value={singleHvac?.hvac_location || ""}
                        label="HVAC Location"
                        onChange={(e) =>
                          setSignleHvac({
                            ...singleHvac,
                            hvac_location: e.target.value,
                          })
                        }
                      >
                        {hvacLocations?.map((data) => (
                          <MenuItem key={data.value} value={data.value}>
                            {data.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {singleHvac?.hvac_location === "new_location_electrical" ||
                  singleHvac?.hvac_location === "new_location_plumbing" ? (
                    <>
                      <Grid item md={6} sm={9} xs={18} mb={3}>
                        <TextField
                          fullWidth
                          label="Number HVAC FT"
                          value={singleHvac?.number_hvac_ft}
                          onChange={(e) =>
                            setSignleHvac({
                              ...singleHvac,
                              number_hvac_ft: Number(e.target.value),
                            })
                          }
                        />
                      </Grid>
                    </>
                  ) : null}

                  {/* Existing Electrical Panel*/}
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        HVAC Horse Power
                      </InputLabel>
                      <Select
                        id="demo-simple-select"
                        value={singleHvac?.hvac_horse_power}
                        label="  HVAC Horse Power"
                        required
                        onChange={(e) =>
                          setSignleHvac({
                            ...singleHvac,
                            hvac_horse_power: e.target.value,
                          })
                        }
                      >
                        {hvacHorsePower?.map((data) => (
                          <MenuItem key={data.value} value={data.value}>
                            {data.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid lg={18} md={18} style={{ textAlign: "center" }}>
                    <Button type="submit" style={{ color: "#4acfac" }}>
                      Add Hvac
                    </Button>
                  </Grid>
                </>
                {/* )} */}
              </Grid>
            </form>
          </Typography>
        </Box>
      </Modal>
      {/* Batteries */}
      <Modal
        open={openBattery}
        onClose={handleCloseBattery}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleHvac}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            align="center"
          >
            <Grid container columns={18}>
              <Grid item lg={18}>
                Add Battery
              </Grid>
            </Grid>
          </Typography>
          <form onSubmit={AddBattery}>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <Grid container columns={18} spacing={2}>
                {/* is_battery*/}
                {/* <Grid item md={6} sm={9} xs={18} mb={3}>
                <InputLabel>Battery</InputLabel>
                <span>No</span>
                <Switch
                  checked={value.is_battery}
                  onChange={(e) =>
                    setValue({
                      ...value,
                      is_battery: e.target.checked,
                    })
                  }
                  inputProps={{ "aria-label": "controlled" }}
                />
                <span>Yes</span>
              </Grid> */}

                {/* number_of_solar_lip  */}
                {/* {value.is_battery && ( */}
                <>
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Battery Power
                      </InputLabel>
                      <Select
                        id="demo-simple-select"
                        value={singleBattery?.battery_power}
                        label="battery_power"
                        required
                        onChange={(e) =>
                          setSignleBattery({
                            ...singleBattery,
                            battery_power: e.target.value,
                          })
                        }
                      >
                        {betteryPower?.map((data) => (
                          <MenuItem key={data.value} value={data.value}>
                            {data.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <TextField
                      fullWidth
                      label="number_of_batteries"
                      required
                      value={singleBattery?.number_of_batteries}
                      onChange={(e) =>
                        setSignleBattery({
                          ...singleBattery,
                          number_of_batteries: Number(e.target.value),
                        })
                      }
                    />
                  </Grid>
                  <Grid lg={18} md={18} style={{ textAlign: "center" }}>
                    <Button
                      style={{ color: "#4acfac" }}
                      type="submit"
                      // onClick={async () => {}
                    >
                      Add Battery
                    </Button>
                  </Grid>
                </>
                {/* )} */}
              </Grid>
            </Typography>
          </form>
        </Box>
      </Modal>
      {/* Generators */}
      <Modal
        open={openGenerator}
        onClose={handleCloseGenerator}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleHvac}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            align="center"
          >
            <Grid container columns={18}>
              <Grid item lg={18}>
                Add Generator
              </Grid>
            </Grid>
          </Typography>
          <form onSubmit={AddGenerator}>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <Grid container columns={18} spacing={2}>
                <>
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Generator Power
                      </InputLabel>
                      <Select
                        id="demo-simple-select"
                        value={singleGenerator?.generator_power}
                        label="Generator Power"
                        required
                        onChange={(e) =>
                          setSignleGenerator({
                            ...singleGenerator,
                            generator_power: e.target.value,
                          })
                        }
                      >
                        {generatorPower?.map((data) => (
                          <MenuItem key={data.value} value={data.value}>
                            {data.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} sm={9} xs={18} mb={3}>
                    <TextField
                      fullWidth
                      label="Number of Generators"
                      required
                      value={singleGenerator?.number_of_generators}
                      onChange={(e) =>
                        setSignleGenerator({
                          ...singleGenerator,
                          number_of_generators: Number(e.target.value),
                        })
                      }
                    />
                  </Grid>
                  <Grid lg={18} md={18} style={{ textAlign: "center" }}>
                    <Button
                      style={{ color: "#4acfac" }}
                      type="submit"
                      // onClick={async () => {}
                    >
                      Add Generator
                    </Button>
                  </Grid>
                </>
                {/* )} */}
              </Grid>
            </Typography>
          </form>
        </Box>
      </Modal>
    </>
  );
};
const CalcToggle = styled.div`
  position: fixed;
  top: 20%;
  right: 1%;
  transform: translate(-20%, -1%);
  width: 60px;
  height: 60px;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  padding: 0.2rem;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  cursor: pointer;
  svg {
    font-size: 2.8rem;
    color: #0dc091;
  }
`;
const FormConatiner = styled.div`
  position: relative;
  .hvac {
    position: relative;
  }
  .btn {
    /* position: absolute; */
    /* left: 0; */
    /* top: 1.5rem; */
    font-size: 0.8rem;
    color: black;
    background-color: #f0f0f0;
  }
`;
const SolarHeading = styled.div`
  text-align: center;
  text-transform: uppercase;
  h2 {
    font-size: 2.5rem;
    color: #0dbf7c55;
    margin-bottom: 1.5rem;
    margin-top: 1rem;
  }
`;
const ClacButton = styled.div`
  width: 50%;
  margin: 1rem auto;
  button {
    border-radius: 2rem;
    letter-spacing: 2px;
    word-spacing: 6px;
    font-size: 0.8rem;
    padding: 0.7rem 1rem;
    background: #eea700;
  }
`;
const ButtonContainer = styled.div`
  text-align: center;
  button {
    border-radius: 2rem;
    padding: 0.7rem 3rem;
    background-size: 400% 100%;
    transition: all 0.4s ease-in-out;
    background-image: linear-gradient(
      132.6deg,
      rgba(71, 139, 214, 1) 23.3%,
      rgba(37, 216, 211, 1) 84.7%
    );
    &:hover {
      background-position: 100% 0;
    }
  }
`;

const ContractorStyled = styled.div`
  padding: 0.5rem 2rem 1.5rem;
  border-bottom: 1px solid #999;
  @media (max-width: 600px) {
    padding: 0.5rem 0rem 0.5rem;
  }
  .contactorData {
    display: flex;
    align-items: center;
    .title {
      display: flex;
      align-items: center;
      width: 200px;
      color: #69aaf0;
      font-weight: 600;
      @media (max-width: 600px) {
        width: auto;
        margin-right: 0.2rem;
        font-size: 1rem;
      }
      svg {
        font-size: 1.5rem;
        margin-right: 0.5rem;
      }
    }
    .value {
      font-size: 1.1rem;
      color: #777;
      text-transform: capitalize;
      font-weight: 400;
      @media (max-width: 600px) {
        font-size: 1rem;
      }
    }
  }
`;
const PrettoSlider = styled(Slider)({
  color: "#52af77",
  height: 8,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&:before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: "#52af77",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&:before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});

const LoadingContainer = styled.div`
  width: 100%;
  height: 50vh;
`;
const UserData = styled.div`
  .leadInfo {
    text-align: center;
    color: #0dbf7c55;
    margin-bottom: 1rem;
  }
  .data {
    display: flex;
    margin: 0.3rem;
    .key {
      text-transform: capitalize;
      margin-right: 0.5rem;
      min-width: 5rem;
      color: #474747;
      display: flex;
      align-items: center;
      svg {
        margin-right: 0.5rem;
      }
    }
    .value {
      color: #888;
    }
  }
`;
const ModelConatiner = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  .icon {
    svg {
      color: #0dc091;
      font-size: 5rem;
    }
  }
  p {
    font-size: 1.5rem;
    text-transform: capitalize;
    margin: 1.5rem;
    color: #777;
  }
  .btn_sucess {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    margin: 1rem 0;
    .go_lead {
      background: #0dc091;
    }

    .add_lead {
      background: #979696;
    }
  }
`;
const CalcSunLightData = styled.div`
  border: 1px solid #eea700;
  padding: 2rem;
  border-radius: 1rem;
  text-align: center;
  height: 190px;
  span {
    display: block;
    font-size: 2.2rem;
    color: #eea700;
    font-weight: bold;
  }
`;
// const InputLabelStyled = styled(InputLabel)`
//   color: #010110;
// `;
// const TextFieldStyled = styled(TextField)`
//   input {
//     border-radius: 1.5rem;
//     box-shadow: 0px 3px 11px 0px inset rgb(0 0 0 / 20%);
//     &:focus {
//       box-shadow: 0px 0px 9px 0px inset rgb(133 206 203 / 65%);
//     }
//   }
//   fieldset {
//     border: 0;
//     outline: 0;
//   }
// `;

const ColorRoofing = styled.div`
  cursor: pointer;
  color: #b8b8b8;
  width: 100%;
  .select-box {
    position: relative;
    width: 100%;
    color: #fff;

    &__current {
      position: relative;
      width: 100%;
      &:focus {
        & + .select-box__list {
          opacity: 1;
          z-index: 10;
          .select-box__option {
            cursor: pointer;
          }
        }
      }
    }
    &__value {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &__input {
      display: none;
      &:checked + .select-box__input-text {
        display: block;
        background: #444;
      }
    }
    &__input-text {
      display: none;
      cursor: pointer;
      width: 100%;
      height: 55px;
      margin: 0;
      padding: 13px;
      font-weight: bold;

      &.show {
        background: #444;
        display: block;
      }
      &.work {
        background: #222;
        display: block;
      }
      /* background: #ff6161; */
      /* &.work {
        background: #fec983;
      }
      &.stuck {
        background: #ff6161;
      }
      &.done {
        background: #32d392;
      }
      &.high {
        background: #4c4fdb;
      }
      &.low {
        background: #371688;
      }
      &.critical {
        background: #e8677f;
      } */
    }
    &__list {
      position: absolute;
      width: 100%;
      height: 60px;
      list-style: none;
      background: #fff;
      padding-top: 0.5rem;
      z-index: 1;
      opacity: 0;
      box-shadow: 0 5px 15px rgba(56, 59, 61, 0.5);
      transition: all 0.3s;
      &::before {
        content: "";
        position: absolute;
        left: 50%;
        top: -8%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 20px solid #fff;
      }
    }
    &__option {
      padding: 1rem;
      display: block;
      margin: 0.2rem 0;
      transition: all 0.3s;
      &:hover {
        opacity: 0.9;
      }
      /* &.work {
        background: #fec983;
      }
      &.stuck {
        background: #fb6b6b;
      }
      &.done {
        background: #32d392;
      }
      &.high {
        background: #4c4fdb;
      }
      &.low {
        background: #371688;
      }
      &.critical {
        background: #e8677f;
      } */
    }
  }
`;
// const RadioGroupStyled = styled(RadioGroup)`
//   .Mui-checked {
//     background: #748596;
//     label {
//       background: #452145;
//     }
//   }
//   label {
//     background: #000;
//     color: white;
//   }
//   input[type="radio"]:checked {
//      {
//       background-color: #fff;
//     }
//   }
// `;

export default SolarFormProposals;
